import React, { useState, useEffect, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setGeoLoactionStateAction,
  setRegionActions,
  SetClientActions,
  setZoneActions,
  setClientBranchCreateActions,
  setClientBranchesRetrieveActions,
  SetBranchEditActions,
  setEmployeetListsActions,
  SetEmployeeDeleteActions,
  getClientBranchIds,
  getEMployeeInquriyIDS,
  getClientEditActions,
  setUserActions, ///user---manager--list
  SetLeaveTypeActions,
  setTheScopeDetailsExportActions, //scope getlist
  setTheContacteitDetailsExportActions, /// contact edit
  setTheCategorydataDetailsExportActions, // for getting the , category
  setTheSubCategorydataDetailsExportActions, // for getting the subcategoru records
  setTheSubCategorydataEditandcreateDetailsExportActions,
  setthesubcategorybranchActionListed, /// separate---subcategory
  resetOrganizationFilterlist, //. Organization lists
  setTablePositionPersist,
  resetOrganizationRmFilterlist,
  resetClientDivisionLevelDropdown,
} from "../../../Redux/Slice";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/ClientBranches/ClientBrachCreate.scss";
import EmployeeCreate from "../../../Component/MainComponent/Employee/EmployeeCreate";
////---------------Shift-------------------------------
import {
  SetShiftSearchActions,
  setShiftDeletCall,
  setShiftListsActions,
  setClientBranchActions,
} from "../../../Redux/Slice";
import Delete from "../../AppComponent/Popup/Delete";
import ShiftCreateForm from "../../../Component/MainComponent/Shift/ShiftCreateForm";
import "../../../StyleSheet/MainComponent/Shift/Shifts.scss";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import validator from "validator";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import Map from "./Map";
import { useNavigate } from "react-router-dom";
import PlusIcon from "../../../Assets/AppComponent/Asset 9.svg";
import minus from "../../../Assets/AppComponent/Asset 10.svg";
import LImages from "../../../Assets/AppComponent/Union (15).svg";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import zIndex from "@mui/material/styles/zIndex";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dropdownimg from "../../../Assets/AppComponent/Vector (22).svg";
import { Autocomplete, TextField, Chip, Box } from "@mui/material";
import closebtnimg from "../../../Assets/AppComponent/Group 427320024.svg";
import useDebouncedEffect from "use-debounced-effect";

// division_level is a list of strings; older clients may still hold a single string
const toDivisionLevelList = (value) =>
  Array.isArray(value) ? value : value ? [value] : [];

const ClientBranchCreate = (props) => {
  const {
    currentPage,
    setShow,
    show,
    EditId,
    UserEditPopup,
    details,
    setDetails,
    setUserEditPopup,
    Datamonth,
  } = props;

  const [mapCenter, setMapCenter] = useState({
    lat: 13.0843007,
    lng: 80.2704622,
  });

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const state = useSelector((state) => state);
  const [State, setState] = useState([]);

  const Swal = require("sweetalert2");
  const navigator = useNavigate();
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );

  const dispatch = useDispatch();
  const [stateerror, setStateError] = useState("");
  let [nameList, setOptions] = useState([]);
  const [multiselect, setMuliselect] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [RegionError, setRegionError] = useState("");
  const [nameList2, setOptions2] = useState([]);
  const [multiselect1, setMuliselect1] = useState([]);
  const [Client, setClient] = useState([]);
  const [nameList3, setOptions3] = useState([]);
  const [MultiSelect2, setMuliselect2] = useState([]);
  const [ClientError, setClientError] = useState("");
  const [ZoneError, setZoneError] = useState("");
  const [Zone, setZone] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const [multiselect3, setMuliselect3] = useState([]);
  const [DescriptionError, setDescriptionError] = useState("");
  const [clientNameEr, setClientNaaErr] = useState("");
  const [AddressErr, setAddressErr] = useState("");
  const [PhoneError, setPhoneError] = useState("");
  const [EmailErr, setEmailErr] = useState("");
  const [totalLeaveprErr, setToleavePre] = useState();
  const [shifttimeErro, setShiftError] = useState();
  const [personalLevaeErr, setPersonslErr] = useState("");
  const [casualErro, setCasualErr] = useState("");
  const [permissionLeErr, setPermissionErr] = useState("");
  const [LeaveValiErr, setLeaveErr] = useState("");
  const [WbsElementErr, setWbsElemeErr] = useState("");
  const [managerList, setManagerList] = useState([]);
  const [mnagerlistselected, setmanagerlistSelected] = useState();
  const [mangerOPtions, setManagerOptions] = useState();
  const [managerliErro, setMnagerErr] = useState();
  const [stateClicked, setStateClicked] = useState(false);
  const [ErrorInde, setErrInde] = useState(0);

  ///--leavetypes
  const [searchleave, setsearchleave] = useState("");
  const [LeaveOptionse, setLeaveOptions] = useState();
  const [LeaveMultiValues, setLeaveMulitiValues] = useState([]);
  const [BranchAuthorizedval, setBranchAuthorizedval] = useState([]);
  const [branchAuthoOptions, setBranchAuthOptions] = useState([]);
  const [REportingErr, setReportingErr] = useState("");
  const [LeaveTypeErr, setLeaveTypeErr] = useState("");
  const [ExtraLebErr, setLeaveExtracErr] = useState("");
  /// contact person
  const [contactnameerr, setcontactNameerr] = useState("");
  const [contactemail, setcontactEmailerr] = useState("");
  const [ContactphoneErr, setContactPhErr] = useState("");
  const [PasswErr, setPasserr] = useState("");

  ///----Ticketing -----L Details

  const [LOne_user, setLoneusers] = useState([]);
  const [Ltwo_users, setLTwoUsers] = useState([]);
  const [LthreeUsers, setLthreeUsers] = useState([]);

  const [LOne_userErr, setLoneuserserr] = useState([]);
  const [Ltwo_usersErr, setLTwoUserserr] = useState([]);
  const [LthreeUsersErr, setLthreeUserserr] = useState([]);

  const [LOneUserOptions, setLoneOptions] = useState([]);
  const [Ltwooptions, setLtwoOptions] = useState([]);
  const [LthreeOptions, setLthreeOptions] = useState([]);

  const [L1TimeTypeErr, setL1TimeTypeErr] = useState("");
  const [L2TimeTypeErr, setL2TimeTypeErr] = useState("");
  const [L3TimeTypeErr, setL3TimeTypeErr] = useState("");

  const [L1UserTATErr, setL1UserTATErr] = useState("");
  const [L2UserTATErr, setL2UserTATErr] = useState("");
  const [L3UserTATErr, setL3UserTATErr] = useState("");
  const [organizationerro, setorganizationerr] = useState("");

  const [radius_err, setradiuse_err] = useState("");
  const [AttendanceErr, setAttendancesErr] = useState("");

  const capitalizeEachWord = (str) => {
    return str && typeof str === "string"
      ? str
        .split(" ") // Split the string into an array of words
        .map(
          (word) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        ) // Capitalize each word
        .join(" ") // Join the words back into a string
      : ""; // Return an empty string if the input is invalid
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #ced4da",
      borderRadius: "5px",
      // padding: "5px",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#FFEFEA",
      borderRadius: "20px",
      padding: "5px",
      color: "#D55B39",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#D55B39",
      fontWeight: "bold",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#D55B39",
      cursor: "pointer",
      ":hover": {
        color: "#FF0000",
      },
    }),
  };

  let Priorityoptions = [
    {
      value: "0",
      label: "LOW",
    },
    {
      value: "1",
      label: "MEDIUM",
    },
    {
      value: "2",
      label: "HIGH",
    },
  ];

  const optionsforfilter = [
    {
      label: "Active",
      value: true,
    },
    {
      label: "In active",
      value: false,
    },
  ];

  // const getInitials = (name) => {
  //   return name
  //     .split(" ")
  //     .map((word) => word[0])
  //     .join("").toUpperCase();
  // };

  const getInitials = (name) => {
    return name
      .replace(/\d+/g, "") // Remove any numbers
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  let currentDate = new Date();
  let year = currentDate.getFullYear();

  // Calculate the end of the current year
  let endOfYear = new Date(year, 11, 31); // December is 11th month (zero-based index)

  // Format the current date and end of year
  let currentMonth =
    (currentDate.getMonth() + 1 < 10 ? "0" : "") + (currentDate.getMonth() + 1);
  let currentDay =
    (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate();
  let formattedDate = `${year}-${currentMonth}-${currentDay}`;

  let endOfYearMonth =
    (endOfYear.getMonth() + 1 < 10 ? "0" : "") + (endOfYear.getMonth() + 1);
  let endOfYearDay =
    (endOfYear.getDate() < 10 ? "0" : "") + endOfYear.getDate();
  let formattedEndOfYear = `${year}-12-31`;

  const [leaveRadioChecked, setLeaveRadioChecked] = useState(false);
  const [ticketingRadioChecked, setTicketingChecked] = useState(false);
  const [Attendance_verified, setAttendance_verified] = useState(false);

  const [viewpass, setViewpass] = useState(false);
  const [CategoryFields, setCategoryFields] = useState([]);

  const [inputFields, setInputFields] = useState([]);

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleAddFields = (index) => {
    if (inputFields.length != 10) {
      const values = [...inputFields];
      values.push({
        first_name: "",
        email: "",
        phone_number: "",
        password: "",
      });
      setInputFields(values);
    } else {
    }
  };

  const preventTyping = (e) => {
    e.preventDefault();
  };
  function onFocus(event) {
    event.target.showPicker();
  }

  const handleRadioChange = () => {
    setLeaveRadioChecked((prev) => !prev);
  };

  const handleRadioChangeticketing = () => {
    setTicketingChecked((prev) => !prev);
  };
  const handleRadioChangeAttendance = () => {
    setAttendance_verified((prev) => !prev);
  };

  const Handlefragmentchanges = (index, event) => {
    const { name } = event.target;
    const values = [...inputFields];

    if (event.target.name === "first_name") {
      values[index].first_name = event.target.value;
    } else if (event.target.name === "email") {
      values[index].email = event.target.value;
    } else if (event.target.name === "phone_number") {
      values[index].phone_number = event.target.value;
    } else if (event.target.name === "password") {
      values[index].password = event.target.value;
    }

    setInputFields(values);
  };
  const HandletheSubofClient = (datas, categoryIndex, subIndex) => {
    // const Subcategorydataput = [];
    // subCategoryDatalisted.map((item) => {

    //   Subcategorydataput.push({
    //     id: item.issue_sub_id,
    //     is_active: item.is_active.value,
    //     Priority: item.Priority.value,
    //     issue_override: true,
    //     issue_id: item.issue_id,
    //     name: item.name,
    //     // client_id:EditId,
    //   })

    // })

    const categoryedit = {
      data: {
        updateData: [
          {
            id: datas.issue_sub_id,
            is_active: datas.is_active.value,
            Priority: datas.Priority.value,
            issue_override: true,
            issue_id: datas.issue_id,
            name: datas.name,
            // client_id:EditId,
          },
        ],
        // Subcategorydataput
      },
      EditId: EditId,
      Apifunc: 1,
    };
    dispatch(
      setTheSubCategorydataEditandcreateDetailsExportActions(categoryedit),
    );
    const updatedFields = [...CategoryFields]; // Clone the array for immutability
    const subcategoryData =
      updatedFields[categoryIndex]?.categoryname?.subcategorydata;

    subcategoryData[subIndex].issue_override = true; // Update name

    setCategoryFields(updatedFields);
  };

  const HandletheSubcreationsofClient = (datas, categoryIndex, subIndex) => {
    const hasEmptyFields =
      !datas.name || !datas.Priority?.label || !datas.is_active?.label;

    if (hasEmptyFields) {
      // Show error toast if there are empty fields
      toast.error(
        "Please complete all fields before adding a new subcategory.",
      );
    } else {
      const categoryedit = {
        data: {
          name: datas?.name,
          description: null,
          TAT: 0, // tat based mail send functionality
          Priority: datas?.Priority?.value,
          is_active: datas?.is_active.value,
          // "issue_category_id": "3c5ed6f2-8387-428d-8242-599837026b5e", // sub category id
          issue_id: datas?.issue_id, // it's a category id.
          client_id: EditId,
          issue_override: true,
        },
        Apifunc: 2,
        EditId: EditId,
      };

      dispatch(
        setTheSubCategorydataEditandcreateDetailsExportActions(categoryedit),
      );

      const updatedFields = [...CategoryFields]; // Clone the array for immutability
      const subcategoryData =
        updatedFields[categoryIndex]?.categoryname?.subcategorydata;

      subcategoryData[subIndex].issue_override = true; // Update name

      setCategoryFields(updatedFields);
    }
  };

  // const HandletheSubcategorychanges = (index, event, fieldName, datas) => {
  //   const updatedFields = [...CategoryFields]; // Clone the array for immutability
  //   console.log(datas, "datas sadasdasd");

  //   if (fieldName === "Priority") {
  //     updatedFields[index].subcategorydata.Priority = event; // Set the value directly
  //   }
  //   else if (fieldName === "Activity") {
  //     updatedFields[index].subcategorydata.is_active = event; // Set the value directly
  //   }
  //   else if (event?.target?.name === "name") {
  //     updatedFields[index].subcategorydata.name = event.target.value; // Update the correct field inside subcategorydata
  //   }

  //   setCategoryFields(updatedFields);
  // };

  const HandletheSubcategorychanges = (
    categoryIndex,
    subIndex,
    event,
    fieldName,
    subcategory,
  ) => {
    const updatedFields = [...CategoryFields]; // Clone the array for immutability

    // Ensure subcategorydata exists for the selected category
    const subcategoryData =
      updatedFields[categoryIndex]?.categoryname?.subcategorydata;
    if (!subcategoryData || !subcategoryData[subIndex]) {
      console.error("Invalid subcategory index or data structure");
      return;
    }

    // Update the specific subcategory based on fieldName
    if (fieldName === "Priority") {
      subcategoryData[subIndex].Priority = event; // Update Priority
    } else if (fieldName === "Activity") {
      subcategoryData[subIndex].is_active = event; // Update is_active
    } else if (event?.target?.name === "name") {
      subcategoryData[subIndex].name = event.target.value; // Update name
    }
    // subcategoryData[subIndex].issue_override = true; // Update name

    // Update the state
    setCategoryFields(updatedFields);
  };

  const [scopeOPtions, setScopeoptions] = useState([]);
  const [ScopeSearch, setScopeSearch] = useState("");
  const [ScopeValues, setCopeValues] = useState([]);
  const [scopeErr, setScopeErr] = useState("");

  const FEATURE_TYPE = [
    { value: "0", label: "No Sensors Required" },
    { value: "1", label: "Camera Required" },
    { value: "2", label: "Location Required" },
    { value: "3", label: "Camera & Location Required" },
  ];
  const [selectedFeatureType, setSelectedFeatureType] = useState(null);

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    usersearh: "",
    organization_search: "",
    organizationRm_search: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    usersearh: "",
    leavetype: "",
    ScopeSearch: "",
    organization_search: "",
    organizationRm_search: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  const [LeabeRadio, setRadioleave] = useState(false);
  let managerObject = [];
  let rmValuesObject = [];
  let pmValuesObject = [];
  let vhValuesObject = [];
  let LeaveTypeOptions = [];
  let L1userValues = [];
  let L2UserValues = [];
  let L3UserValues = [];
  let ScopeEditValues = [];
  const createnewuser = {
    client_name: "",
    description: "",
    client_id: state.ClientBranchIDs.clientID,
    state_id: "",
    region_id: "",
    zone_id: "",
    Address: "",
    ph: "",
    Email: "",
    total_permissions: "",
    personal_leave: 0,
    casual_leave: 0,
    // leave_valid_until: "",
    // permission_valid_until: "",
    // wbs_element: "",
    manager_ids: [],
    extra_leave: 0,
    leave_types: [],
    supervisor_ids: [],
    l1_user: [],
    l2_user: [],
    l3_user: [],

    l1_time_type: "",
    l2_time_type: "",
    l3_time_type: "",

    l1_user_TAT: "",
    l2_user_TAT: "",
    l3_user_TAT: "",
    scope_ids: [],
    issue_override: false,
    organization_id: "",
    attendance_features: null,
    geo_location_radius: 0,
    is_acitve: true,
    rm_ids: [],
    pm_ids: [],
    vh_ids: [],
    product_code: "",
    division_level: [],
    program_code: "",
    project_code: "",
    client_code: "",
    division_code: "",
    division_name: "",
  };
  var a;

  const [data, setData] = useState(createnewuser);

  // division level is visible only for this organization, fetch its dropdown then
  useEffect(() => {
    if (data?.organization_id == "28e108e0-a644-4365-89df-317867f00f22") {
      dispatch(resetClientDivisionLevelDropdown());
    }
  }, [data?.organization_id]);

  const divisionLevelOptions = (
    state.clientDivisionLevel_dropdown_tocall?.ClientDivisionLevel_records || []
  ).map((level) => ({ value: level, label: level }));
  var DurationOpions = [
    {
      value: "0",
      label: "Minutes",
    },
    {
      value: "1",
      label: "Hours",
    },
    {
      value: "2",
      label: "Day",
    },
  ];
  const [DurationOneval, setDurationoneval] = useState([]);
  const [DurationTwoval, setDurationtwoval] = useState([]);

  const [Durationthreeval, setDurationthreeval] = useState([]);

  const [LonePersonsst, setLevelOnePersonst] = useState(false);
  const [LTwoPersonsst, setLevelTwoPersonst] = useState(false);
  const [LThreePersonsst, setLevelThreePersonst] = useState(false);

  const [Organization_Val, setOrganization_Val] = useState(null);
  const [organization_RM_Val, setOrganization_RM_Val] = useState([]);
  const [organization_PM_Val, setOrganization_PM_Val] = useState([]);
  const [organization_VH_Val, setOrganization_VH_Val] = useState([]);
  const [Organization_options, setOrganizations_options] = useState([]);
  const [Organization_RM_options, setOrganization_RM_options] = useState([]);

  const HandleTheDurations = (e, Names) => {
    if (Names == "l3time_type") {
      setDurationthreeval(e);
      setData({
        ...data,
        l3_time_type: e.value,
      });
    } else if (Names == "l2time_type") {
      setDurationtwoval(e);
      setData({
        ...data,
        l2_time_type: e.value,
      });
    } else if (Names == "l1time_type") {
      setDurationoneval(e);
      setData({
        ...data,
        l1_time_type: e.value,
      });
    }
  };

  const [ScopeCategorydatas, setscopeCategorydatas] = useState([]);
  const [ScopeCategoryIds, setscopeCategoryIds] = useState([]);

  // useEffect(() => {
  //   if (state.Usergetlists.UserList != undefined) {
  //     let ObjectArrayFormager = [];
  //     state.Usergetlists.UserList.forEach((element , index) => {
  //        if(element.id != data.l1_user[index]){
  //       ObjectArrayFormager.push({
  //         value: element.id,
  //         label: element.first_name,
  //       });
  //     }
  //     });
  //     setLtwoOptions(ObjectArrayFormager);
  //   }
  // }, [state.Usergetlists.UserList, SearchedVal.usersearh]);

  useEffect(() => {
    if (state.Usergetlists.UserList !== undefined) {
      let ObjectArrayFormager = [];
      state.Usergetlists.UserList.forEach((element) => {
        if (
          !data.l1_user.includes(String(element.id)) &&
          !data.l3_user.includes(String(element.id))
        ) {
          ObjectArrayFormager.push({
            value: element.id,
            label: capitalizeEachWord(element.first_name.toLowerCase()),
            role: capitalizeEachWord(element.user_role?.role.toLowerCase()),
          });
        }
      });

      setLtwoOptions(ObjectArrayFormager);
    }
  }, [state.Usergetlists.UserList, SearchedVal.usersearh, data.l1_user]);

  useEffect(() => {
    if (state.Usergetlists.UserList !== undefined) {
      let ObjectArrayFormager = [];

      state.Usergetlists.UserList.forEach((element) => {
        if (
          !data.l1_user.includes(String(element.id)) &&
          !data.l2_user.includes(String(element.id))
        ) {
          ObjectArrayFormager.push({
            value: element.id,
            label: capitalizeEachWord(element.first_name.toLowerCase()),
            role: capitalizeEachWord(element.user_role?.role.toLowerCase()),
          });
        }
      });
      setLthreeOptions(ObjectArrayFormager);
    }
  }, [
    state.Usergetlists.UserList,
    SearchedVal.usersearh,
    data.l1_user,
    data.l2_user,
  ]);

  const handlOrganizationList = (selected) => {
    setOrganization_Val(selected);
    setData({
      ...data,
      organization_id: selected?.value,
    });
  };
  const handleRM_List = (e) => {
    console.log(e, "dakllkdakldklas");
    if (e != null) {
      let objectAi = [];
      setOrganization_RM_Val(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        rm_ids: objectAi,
      });
    }
  };
  const handlePM_List = (e) => {
    console.log(e, "dakllkdakldklas");
    if (e != null) {
      let objectAi = [];
      setOrganization_PM_Val(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        pm_ids: objectAi,
      });
    }
  };
  const handleVH_List = (e) => {
    console.log(e, "dakllkdakldklas");
    if (e != null) {
      let objectAi = [];
      setOrganization_VH_Val(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        vh_ids: objectAi,
      });
    }
  };

  /// managerlist --changes--
  const handleMagerList = (e) => {
    if (e != null) {
      let objectAi = [];
      setmanagerlistSelected(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        supervisor_ids: objectAi,
      });
    }
  };

  const handleLoneUsers = (e) => {
    if (e != null) {
      let objectAi = [];

      console.log(e, "sadpsapod asdpoaisdas doasid ");

      setLoneusers(e);

      // if (e.length === 0) {
      //   setLTwoUsers([]);
      //   setLthreeUsers([]);
      // }
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        l1_user: objectAi,
        // l2_user: e.length === 0 ? [] : data.l2_user,
        // l3_user: e.length === 0 ? [] : data.l3_user,
      });
    }
  };

  const handleLTwoUsers = (e) => {
    if (e != null) {
      let objectAi = [];
      setLTwoUsers(e);
      // if (e.length === 0) {
      //   setLthreeUsers([]);
      // }
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        l2_user: objectAi,
        // l3_user: e.length == 0 ? [] : data.l3_user
      });
    }
  };

  const handleLThreeUsers = (e) => {
    if (e != null) {
      let objectAi = [];
      setLthreeUsers(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        l3_user: objectAi,
      });
    }
  };

  const handlethescopeValues = (e) => {
    if (e != null) {
      let objectAi = [];
      setCopeValues(e);
      e.map((item) => {
        objectAi.push(item.value);
      });
      setData({
        ...data,
        scope_ids: objectAi,
      });
    }
  };

  const handleRemove = (itemToRemove) => {
    setLoneusers((prev) =>
      prev.filter((item) => item.value !== itemToRemove.value),
    );
    const updatedLoneusers = LOne_user.filter(
      (item) => item.value !== itemToRemove.value,
    ).map((item) => item.value); // Extract only the value properties

    setData({
      ...data,
      l1_user: updatedLoneusers,
    });
  };
  console.log("sd updatedLoneusers", data.l1_user);

  const handleRemoveperson2 = (itemToRemove) => {
    setLTwoUsers((prev) =>
      prev.filter((item) => item.value !== itemToRemove.value),
    );
    const updatedLoneusers = Ltwo_users.filter(
      (item) => item.value !== itemToRemove.value,
    ).map((item) => item.value); // Extract only the value properties

    setData({
      ...data,
      l2_user: updatedLoneusers,
    });
  };

  const handleRemoveperson3 = (itemToRemove) => {
    setLthreeUsers((prev) =>
      prev.filter((item) => item.value !== itemToRemove.value),
    );
    const updatedLoneusers = LthreeUsers.filter(
      (item) => item.value !== itemToRemove.value,
    ).map((item) => item.value); // Extract only the value properties

    setData({
      ...data,
      l3_user: updatedLoneusers,
    });
  };

  const handleSelectChange = (selectedVal) => {
    // console.log(selectedVal, "valuesss");
    setmanagerlistSelected([]);
    setMuliselect(selectedVal);
    setMuliselect1([]);
    setMuliselect3([]);
    setData({
      ...data,
      state_id: selectedVal.value,
      region: "",
      zone: "",
      region_id: "",
      zone_id: "",
      supervisor_ids: [],
    });
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          usersearh: SearchDebounance.usersearh,
          organization_search: SearchDebounance.organization_search,
          organizationRm_search: SearchDebounance.organizationRm_search,
        });
        setsearchleave(SearchDebounance.leavetype);
        setScopeSearch(SearchDebounance.ScopeSearch);
      }
    },
    500,
    [SearchDebounance],
  );
  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };
  //---Zone----
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };
  ///----Regions----
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  const handleInputuser = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      usersearh: Val,
    });
  };

  const handleInputOrganization = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      organization_search: Val,
    });
  };
  const handleInputOrganizationRm = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      organizationRm_search: Val,
    });
  };

  ////------------------Edits
  useEffect(() => {
    if (EditId != undefined) {
      const payload = {
        EditId: EditId,
      };
      dispatch(setClientBranchesRetrieveActions(payload));
    }
  }, [EditId]);

  useEffect(() => {
    const defaultFields = [
      // {
      //   first_name: "",
      //   email: "",
      //   phone_number: "",
      //   password: "",
      // },
    ];
    console.log(
      state.BranchRetrieve.BranchesRetrieve,
      "asoduas dstate.BranchRetrieve.BranchesRetrieve",
    );

    if (EditId !== undefined) {
      const clientUsers = state.BranchRetrieve.BranchesRetrieve.client_users;

      if (
        clientUsers != undefined &&
        clientUsers != null &&
        Array.isArray(clientUsers) &&
        clientUsers.length > 0
      ) {
        console.log(
          clientUsers,
          "state.BranchRetrieve.BranchesRetrieve.client_users",
        );

        const filteredDefaultFields = defaultFields.filter(
          (field) =>
            field.first_name &&
            field.email &&
            field.phone_number &&
            field.password,
        );

        setInputFields(
          filteredDefaultFields.concat(
            clientUsers.map((item) => ({
              id: item.id,
              first_name: item.first_name,
              email: item.email,
              phone_number: item.phone_number,
              password: "",
            })),
          ),
        );
      } else if (clientUsers == undefined || clientUsers.length == 0) {
        // empty one
        setInputFields([
          {
            first_name: "",
            email: "",
            phone_number: "",
            password: "",
          },
        ]);
      }
    } else if (EditId === undefined) {
      setInputFields([
        {
          first_name: "",
          email: "",
          phone_number: "",
          password: "",
        },
      ]);
    }
  }, [state.BranchRetrieve.BranchesRetrieve, EditId]);

  // console.log(inputFields, "asoiduasod ", state.BranchRetrieve.BranchesRetrieve, EditId);

  useEffect(() => {
    if (EditId != undefined) {
      if (state.BranchRetrieve.BranchesRetrieve.id) {
        let manageris = [];
        let LeaveTypeIDs = [];
        let l1Users = [];
        let L2users = [];
        let L3Users = [];
        let ScopeIDS = [];
        let rmIds = [];
        let pmIds = [];
        let vhIds = [];
        setData({
          ...data,
          client_name: state.BranchRetrieve.BranchesRetrieve.client_name,
          description:
            state.BranchRetrieve.BranchesRetrieve.short_description == null
              ? ""
              : state.BranchRetrieve.BranchesRetrieve.short_description,
          //client_id: state.BranchRetrieve.BranchesRetrieve.client_id.id,
          state_id: state.BranchRetrieve.BranchesRetrieve.state_id.id,
          region_id: state.BranchRetrieve.BranchesRetrieve.region_id.id,
          zone_id: state.BranchRetrieve.BranchesRetrieve.zone_id.id,
          Email: state.BranchRetrieve.BranchesRetrieve.email,
          ph: state.BranchRetrieve.BranchesRetrieve.phone_number,
          Address: state.BranchRetrieve.BranchesRetrieve.address,
          total_leave: state.BranchRetrieve.BranchesRetrieve.total_leave,
          // total_permissions:
          //   state.BranchRetrieve.BranchesRetrieve.total_permissions,
          personal_leave: state.BranchRetrieve.BranchesRetrieve.personal_leave,
          casual_leave: state.BranchRetrieve.BranchesRetrieve.casual_leave,
          extra_leave: state.BranchRetrieve.BranchesRetrieve.extra_leave,
          // leave_valid_until:
          //   state.BranchRetrieve.BranchesRetrieve.leave_valid_until,
          // permission_valid_until:
          //   state.BranchRetrieve.BranchesRetrieve.permission_valid_until,
          // wbs_element: state.BranchRetrieve.BranchesRetrieve.wbs_element,

          supervisor_ids: manageris,
          rm_ids: rmIds,
          pm_ids: pmIds,
          vh_ids: vhIds,
          leave_types: LeaveTypeIDs,
          l1_user: l1Users,
          l2_user: L2users,
          l3_user: L3Users,

          l1_time_type: state.BranchRetrieve.BranchesRetrieve.l1_time_type,
          l2_time_type: state.BranchRetrieve.BranchesRetrieve.l2_time_type,
          l3_time_type: state.BranchRetrieve.BranchesRetrieve.l3_time_type,

          l1_user_TAT: state.BranchRetrieve.BranchesRetrieve.l1_user_TAT,
          l2_user_TAT: state.BranchRetrieve.BranchesRetrieve.l2_user_TAT,
          l3_user_TAT: state.BranchRetrieve.BranchesRetrieve.l3_user_TAT,
          product_code: state.BranchRetrieve.BranchesRetrieve.product_code,
          division_level: toDivisionLevelList(
            state.BranchRetrieve.BranchesRetrieve.division_level,
          ),
          program_code: state.BranchRetrieve.BranchesRetrieve.program_code,
          project_code: state.BranchRetrieve.BranchesRetrieve.project_code,
          client_code: state.BranchRetrieve.BranchesRetrieve.client_code,
          division_code: state.BranchRetrieve.BranchesRetrieve.division_code,
          division_name: state.BranchRetrieve.BranchesRetrieve.division_name,
          scope_ids: ScopeIDS,
          organization_id:
            state.BranchRetrieve.BranchesRetrieve.organization_id != null
              ? state.BranchRetrieve.BranchesRetrieve.organization_id?.id
              : "",
          attendance_features:
            state.BranchRetrieve.BranchesRetrieve?.attendance_features != null
              ? state.BranchRetrieve.BranchesRetrieve?.attendance_features
              : "",
          geo_location_radius: state.BranchRetrieve.BranchesRetrieve
            ?.geo_location_radius
            ? state.BranchRetrieve.BranchesRetrieve?.geo_location_radius
            : 0,
        });
        if (
          state.BranchRetrieve.BranchesRetrieve?.attendance_features != null
        ) {
          const selectedFeature = FEATURE_TYPE.find(
            (item) =>
              item.value ===
              String(state.BranchRetrieve.BranchesRetrieve.attendance_features),
          );

          setAttendance_verified(
            state.BranchRetrieve.BranchesRetrieve?.is_attendance_active,
          );
          setSelectedFeatureType(selectedFeature || null);
        }
        if (
          state.BranchRetrieve.BranchesRetrieve?.attendance_features == null
        ) {
          setSelectedFeatureType(null);
        }
        if (state.BranchRetrieve.BranchesRetrieve?.organization_id) {
          setOrganization_Val({
            value: state.BranchRetrieve.BranchesRetrieve?.organization_id?.id,
            label:
              state.BranchRetrieve.BranchesRetrieve?.organization_id
                ?.organization_name,
          });
        }
        if (
          state.BranchRetrieve.BranchesRetrieve.l1_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l2_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l3_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l1_time_type != "" &&
          state.BranchRetrieve.BranchesRetrieve.l2_time_type != "" &&
          state.BranchRetrieve.BranchesRetrieve.l3_time_type != ""
        ) {
          setDurationoneval({
            value: state.BranchRetrieve.BranchesRetrieve.l1_time_type,
            label:
              state.BranchRetrieve.BranchesRetrieve.l1_time_type == 0
                ? "Minutes"
                : state.BranchRetrieve.BranchesRetrieve.l1_time_type == 1
                  ? "Hours"
                  : state.BranchRetrieve.BranchesRetrieve.l1_time_type == 2 &&
                  "Day",
          });

          setDurationtwoval({
            value: state.BranchRetrieve.BranchesRetrieve.l2_time_type,
            label:
              state.BranchRetrieve.BranchesRetrieve.l2_time_type == 0
                ? "Minutes"
                : state.BranchRetrieve.BranchesRetrieve.l2_time_type == 1
                  ? "Hours"
                  : state.BranchRetrieve.BranchesRetrieve.l2_time_type == 2 &&
                  "Day",
          });
          setDurationthreeval({
            value: state.BranchRetrieve.BranchesRetrieve.l3_time_type,
            label:
              state.BranchRetrieve.BranchesRetrieve.l3_time_type == 0
                ? "Minutes"
                : state.BranchRetrieve.BranchesRetrieve.l3_time_type == 1
                  ? "Hours"
                  : state.BranchRetrieve.BranchesRetrieve.l3_time_type == 2 &&
                  "Day",
          });
        }

        if (
          (state.BranchRetrieve.BranchesRetrieve.l1_time_type == null &&
            state.BranchRetrieve.BranchesRetrieve.l2_time_type == null &&
            state.BranchRetrieve.BranchesRetrieve.l3_time_type == null) ||
          (state.BranchRetrieve.BranchesRetrieve.l1_time_type == "" &&
            state.BranchRetrieve.BranchesRetrieve.l2_time_type == "" &&
            state.BranchRetrieve.BranchesRetrieve.l3_time_type == "")
        ) {
          setDurationoneval({});

          setDurationtwoval({});
          setDurationthreeval({});
        }
        if (
          state.BranchRetrieve.BranchesRetrieve.client_users.length > 0 &&
          state.BranchRetrieve.BranchesRetrieve.l1_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l2_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l3_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l1_user?.length > 0 &&
          state.BranchRetrieve.BranchesRetrieve.l2_user?.length > 0 &&
          state.BranchRetrieve.BranchesRetrieve.l3_user?.length > 0 &&
          state.BranchRetrieve.BranchesRetrieve.l1_user_TAT != null &&
          state.BranchRetrieve.BranchesRetrieve.l2_user_TAT != null &&
          state.BranchRetrieve.BranchesRetrieve.l3_user_TAT != null
        ) {
          setTicketingChecked(true);
        } else if (
          state.BranchRetrieve.BranchesRetrieve.client_users.length == 0 &&
          state.BranchRetrieve.BranchesRetrieve.l1_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l2_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l3_time_type != null &&
          state.BranchRetrieve.BranchesRetrieve.l1_user?.length > 0 &&
          state.BranchRetrieve.BranchesRetrieve.l2_user?.length > 0 &&
          state.BranchRetrieve.BranchesRetrieve.l3_user?.length > 0 &&
          state.BranchRetrieve.BranchesRetrieve.l1_user_TAT != null &&
          state.BranchRetrieve.BranchesRetrieve.l2_user_TAT != null &&
          state.BranchRetrieve.BranchesRetrieve.l3_user_TAT != null
        ) {
          setTicketingChecked(true);
        } else {
          setTicketingChecked(false);
        }

        setMapCenter({
          ...mapCenter,
          lat: Number(state.BranchRetrieve.BranchesRetrieve.latitude),
          lng: Number(state.BranchRetrieve.BranchesRetrieve.longitude),
        });
        setLeaveRadioChecked(state.BranchRetrieve.BranchesRetrieve.has_leave);
        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.supervisor_ids != undefined &&
          state.BranchRetrieve.BranchesRetrieve.supervisor_ids != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.supervisor_ids.map((item) => {
            manageris.push(item.id);
            managerObject.push({ value: item.id, label: item.first_name });
          });
        }
        setmanagerlistSelected(managerObject);
        if (
          state.BranchRetrieve.BranchesRetrieve !== undefined &&
          state.BranchRetrieve.BranchesRetrieve.rm_ids !== undefined &&
          state.BranchRetrieve.BranchesRetrieve.rm_ids !== null
        ) {
          // check if already exists
          state.BranchRetrieve.BranchesRetrieve.rm_ids.map((item) => {
            rmIds.push(item.id);
            rmValuesObject.push({
              value: item.id,
              label: item.first_name + " " + item.last_name,
            });
          });
        }

        setOrganization_RM_Val(rmValuesObject);
        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.pm_ids != undefined &&
          state.BranchRetrieve.BranchesRetrieve.pm_ids != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.pm_ids.map((item) => {
            pmIds.push(item.id);
            pmValuesObject.push({
              value: item.id,
              label: item.first_name + " " + item.last_name,
            });
          });
        }
        setOrganization_PM_Val(pmValuesObject);
        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.vh_ids != undefined &&
          state.BranchRetrieve.BranchesRetrieve.vh_ids != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.vh_ids.map((item) => {
            vhIds.push(item.id);
            vhValuesObject.push({
              value: item.id,
              label: item.first_name + " " + item.last_name,
            });
          });
        }
        setOrganization_VH_Val(vhValuesObject);

        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.l1_user != undefined &&
          state.BranchRetrieve.BranchesRetrieve.l1_user != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.l1_user.map((item) => {
            l1Users.push(item.id);
            L1userValues.push({
              value: item.id,
              label: capitalizeEachWord(item.first_name.toLowerCase()),
              role: capitalizeEachWord(item?.user_role?.role.toLowerCase()),
            });
          });
        }

        setLoneusers(L1userValues);
        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.scope_ids != undefined &&
          state.BranchRetrieve.BranchesRetrieve.scope_ids != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.scope_ids.map((item) => {
            ScopeIDS.push(item.id);

            ScopeEditValues.push({ value: item.id, label: item.scope_name });
          });
        }

        setCopeValues(ScopeEditValues);

        // setCopeValues

        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.l2_user != undefined &&
          state.BranchRetrieve.BranchesRetrieve.l2_user != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.l2_user.map((item) => {
            L2users.push(item.id);
            L2UserValues.push({
              value: item.id,
              label: capitalizeEachWord(item.first_name.toLowerCase()),
              role: capitalizeEachWord(item?.user_role?.role.toLowerCase()),
            });
          });
        }
        setLTwoUsers(L2UserValues);

        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.l3_user != undefined &&
          state.BranchRetrieve.BranchesRetrieve.l3_user != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.l3_user.map((item) => {
            L3Users.push(item.id);
            L3UserValues.push({
              value: item.id,
              label: capitalizeEachWord(item.first_name.toLowerCase()),
              role: capitalizeEachWord(item?.user_role?.role.toLowerCase()),
            });
          });
        }
        setLthreeUsers(L3UserValues);

        if (
          state.BranchRetrieve.BranchesRetrieve != undefined &&
          state.BranchRetrieve.BranchesRetrieve.leave_types != undefined &&
          state.BranchRetrieve.BranchesRetrieve.leave_types != null
        ) {
          state.BranchRetrieve.BranchesRetrieve.leave_types.map((item) => {
            LeaveTypeIDs.push(item.id);
            LeaveTypeOptions.push({ value: item.id, label: item.leave_type });
          });
        }
        setLeaveMulitiValues(LeaveTypeOptions);
      }
    }
  }, [state.BranchRetrieve.BranchesRetrieve]);

  ///-----Edit----Selects--------------

  const [SelectedState, setStateSelect] = useState([]);
  const [SelectedStates, SetStates] = useState([]);
  const [SelectedZone, setZoneSelected] = useState([]);
  const [SelectRegion, setSlectRegions] = useState([]);
  const [SelectedClient, setSelectedclient] = useState([]);
  useEffect(() => {
    if (state.BranchRetrieve.BranchesRetrieve.id != undefined) {
      let objectedit = [];

      objectedit.push({
        value: state.BranchRetrieve.BranchesRetrieve.client_id.id,
        label: state.BranchRetrieve.BranchesRetrieve.client_id.client_name,
      });
      setSelectedclient(objectedit);

      let objectZone = [];
      objectZone.push({
        value: state.BranchRetrieve.BranchesRetrieve.zone_id.id,
        label: state.BranchRetrieve.BranchesRetrieve.zone_id.zone_name,
      });
      setZoneSelected(objectZone);

      let objectRegion = [];
      objectRegion.push({
        value: state.BranchRetrieve.BranchesRetrieve.region_id.id,
        label: state.BranchRetrieve.BranchesRetrieve.region_id.region_name,
      });
      setSlectRegions(objectRegion);
    }
  }, [state.BranchRetrieve.BranchesRetrieve.id]);

  useEffect(() => {
    if (
      state.BranchRetrieve.BranchesRetrieve.id != undefined &&
      state.BranchRetrieve.BranchesRetrieve.state_id.id != undefined
    ) {
      let objectState = [];
      objectState.push({
        value: state.BranchRetrieve.BranchesRetrieve.state_id.id,
        label: state.BranchRetrieve.BranchesRetrieve.state_id.state_name,
      });
      SetStates(objectState);
    }
  }, [state.BranchRetrieve.BranchesRetrieve.id]);

  const [stateMul, setStateMul] = useState([]);
  const [regionSelected, setRegionMUl] = useState([]);
  const [ZoneMulEdi, setZoneMulEdi] = useState([]);
  const [SelectedMul, setSelectedMul] = useState([]);
  const handleState = (sel) => {
    setmanagerlistSelected([]);
    setStateMul(sel);
    SetStates(sel);
    setSlectRegions([]);
    setZoneSelected([]);
    setData({
      ...data,
      state_id: sel.value,
      region_id: "",
      zone_id: "",
      supervisor_ids: [],
    });
  };
  const handleRegionSelected = (sel) => {
    setRegionMUl(sel);
    setSlectRegions(sel);
    setZoneSelected([]);

    setData({
      ...data,
      region_id: sel.value,
      zone_id: "",
    });
  };
  const handleZoneEdits = (sel) => {
    setZoneMulEdi(sel);
    setZoneSelected(sel);
    setData({
      ...data,
      zone_id: sel.value,
    });
  };

  const handleEditSelected = (sel) => {
    setSelectedMul(sel);
    setSelectedclient(sel);
    setData({
      ...data,
      client_id: sel.value,
    });
  };
  const handleFeatureTypeChange = (selected) => {
    setSelectedFeatureType(selected);
    setData({
      ...data,
      attendance_features: selected?.value,
    });
    setAttendancesErr("");
  };

  ///--------------Organizations-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.organization_search,
      page_size: "20",
      page: 1,
    };
    dispatch(resetOrganizationFilterlist(payloads));
  }, [SearchedVal.organization_search]);
  useEffect(() => {
    if (data?.organization_id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e") {
      const payloads = {
        search: SearchedVal.organizationRm_search,
        page_size: "20",
        page: 1,
        org_ids: "11a8ab83-0669-4098-a453-ddb2a2e0c39e",
      };
      dispatch(resetOrganizationRmFilterlist(payloads));
    }
  }, [SearchedVal.organizationRm_search, data?.organization_id]);

  useEffect(() => {
    if (state.organization_filterlist_tocall.Organization_filterlist_records) {
      let ObjectArrayFormager = [];
      state.organization_filterlist_tocall.Organization_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.organization_name,
          });
        },
      );
      setOrganizations_options(ObjectArrayFormager);
    }
  }, [
    state.organization_filterlist_tocall.Organization_filterlist_records,
    SearchedVal.organization_search,
  ]);
  useEffect(() => {
    if (
      state.organizationRm_filterlist_tocall.OrganizationRm_filterlist_records
    ) {
      let ObjectArrayFormager = [];
      state.organizationRm_filterlist_tocall.OrganizationRm_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.first_name + " " + element.last_name,
          });
        },
      );
      setOrganization_RM_options(ObjectArrayFormager);
    }
    console.log(state.organizationRm_filterlist_tocall, "dklalkklaskdkaksd");
  }, [
    state.organizationRm_filterlist_tocall.OrganizationRm_filterlist_records,
    SearchedVal.organizationRm_search,
    data?.organization_id,
  ]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  useEffect(() => {
    const payloads = {
      search: ScopeSearch,
      page_size: "20",
      page: 1,
    };

    dispatch(setTheScopeDetailsExportActions(payloads));
  }, [ScopeSearch]);
  /// categorygetlist

  useEffect(() => {
    if (state.SubCategoryListed?.SubcategoryDatas != undefined) {
      let objectArray = [];
      var scopeidss = [];
      state.SubCategoryListed?.SubcategoryDatas.forEach((element) => {
        // objectArray.push({ value: element.id, label: element.name });
        console.log(element, "element", element?.issue_category_id);

        scopeidss.push(element?.issue_category_id?.id);
      });

      // setscopeCategorydatas(objectArray);
      setscopeCategoryIds(scopeidss);
    }
  }, [state.SubCategoryListed?.SubcategoryDatas]);

  useEffect(() => {
    if (EditId == undefined && data.scope_ids.length > 0) {
      const payloads = {
        scope: JSON.stringify(data.scope_ids),
      };
      dispatch(setTheCategorydataDetailsExportActions(payloads));

      const payloadssubcategory = {
        // client:EditId != undefined ?EditId :"" ,
        Scopeid: 2,
        paramslist: {
          scope: JSON.stringify(data.scope_ids),
        },
      };
      dispatch(setTheSubCategorydataDetailsExportActions(payloadssubcategory));
    }
  }, [data.scope_ids]);
  //. sub category
  useEffect(() => {
    if (data.scope_ids.length > 0) {
      if (
        state.BranchRetrieve.BranchesRetrieve != undefined &&
        state.BranchRetrieve.BranchesRetrieve.scope_ids != undefined &&
        state.BranchRetrieve.BranchesRetrieve.scope_ids != null &&
        EditId != undefined
      ) {
        const payloads = {
          // scope: EditId == undefined && JSON.stringify(data.scope_ids),
          Scopeid: 1,
          paramslist: {
            client: EditId,
          },
        };

        dispatch(setTheSubCategorydataDetailsExportActions(payloads));

        const payloadssub = {
          paramslist: {
            // client: EditId,
            scope: JSON.stringify(data.scope_ids),
          },
        };
        dispatch(setthesubcategorybranchActionListed(payloadssub));
      }
    }

    // data.scope_ids
  }, [data.scope_ids]);

  useEffect(() => {
    if (state.CategoryListed?.CategoryDatas != undefined) {
      let objectArray = [];
      let scopeids = [];
      state.CategoryListed?.CategoryDatas.forEach((element) => {
        objectArray.push({ value: element.id, label: element.name });
        // scopeids.push(element.id)
      });

      setscopeCategorydatas(objectArray);
      // setscopeCategoryIds(scopeids);
    }
  }, [state.CategoryListed?.CategoryDatas]);

  useEffect(() => {
    if (EditId !== undefined) {
      const categoryMap = []; // Use a map to track unique categories

      if (data.scope_ids.length > 0) {
        if (
          Array.isArray(state.SubCategoryListed.SubcategoryDatas) &&
          state.SubCategoryListed.SubcategoryDatas.length > 0
        ) {
          const uniqueCategoryMap = {}; // Object to track unique issue_id.id

          const uniqueCategoryaddedscope = {};

          const formattedData = state.SubCategoryListed.SubcategoryDatas.reduce(
            (acc, item) => {
              const issueId = item.issue_id?.id; // Extract the issue_id.id

              const subCategoryData = {
                id: item?.id, // Subcategory ID
                name: item.name, // Use name based on condition
                Priority: {
                  value: item?.Priority,
                  label:
                    item?.Priority === "0"
                      ? "Low"
                      : item?.Priority === "1"
                        ? "Medium"
                        : item?.Priority === "2"
                          ? "High"
                          : "",
                },
                issue_id: issueId, // Actual category ID
                is_active: {
                  value: item?.is_active,
                  label: item?.is_active ? "Active" : "In active",
                },
                issue_sub_id: item?.id,
                categoryname: item.issue_id?.name,
                fieldsAdded: false,
                issue_override: item.issue_override,
              };

              // Check if the issue_id.id is already present in the map
              if (!uniqueCategoryMap[issueId]) {
                uniqueCategoryMap[issueId] = {
                  categoryname: {
                    name: item.issue_id?.name,
                    subcategorydata: [subCategoryData], // Add the subcategory data
                    id: issueId,
                    Hideshow: false,
                    issue_override: item.issue_override,
                  },
                };

                // console.log(uniqueCategoryMap[issueId], uniqueCategoryMap, "subCategoryData subCategoryData");
              } else {
                // Add the subcategory to the existing category if the issue_category is different
                // if (
                //   !uniqueCategoryMap[issueId].categoryname.subcategorydata.some(
                //     (existingSubcategory) => existingSubcategory.name === subCategoryData.name
                //   )
                // ) {
                //   uniqueCategoryMap[issueId].categoryname.subcategorydata.push(subCategoryData);
                // }

                const subcategoryExists = uniqueCategoryMap[
                  issueId
                ].categoryname.subcategorydata.some(
                  (existingSubcategory) =>
                    existingSubcategory.id === subCategoryData.id,
                );

                if (!subcategoryExists) {
                  // Add the new subcategory to the subcategorydata array
                  uniqueCategoryMap[issueId].categoryname.subcategorydata.push(
                    subCategoryData,
                  );
                }
              }

              return acc;
            },
            [],
          );
          // Convert the unique categories map to an array
          const formattedCategoryData = Object.values(uniqueCategoryMap);

          const formattedaddedscopeData =
            state.SubCategorySlicedatas.BranchSubcategorylisted.reduce(
              (acc, item) => {
                const issueId = item.issue_category_id?.id; // Extract the issue_id.id

                const subCategoryData = {
                  id: item?.id, // Subcategory ID
                  name: item.name, // Use name based on condition
                  Priority: {
                    value: item?.Priority,
                    label:
                      item?.Priority === "0"
                        ? "Low"
                        : item?.Priority === "1"
                          ? "Medium"
                          : item?.Priority === "2"
                            ? "High"
                            : "",
                  },
                  issue_id: issueId, // Actual category ID
                  is_active: {
                    value: item?.is_active,
                    label: item?.is_active ? "Active" : "In active",
                  },
                  issue_sub_id: item?.id,
                  categoryname: item.issue_category_id?.name,
                  fieldsAdded: false,
                  issue_override: false,
                };

                // Check if the issue_id.id is already present in the map
                if (!uniqueCategoryaddedscope[issueId]) {
                  uniqueCategoryaddedscope[issueId] = {
                    categoryname: {
                      name: item.issue_category_id?.name,
                      subcategorydata: [subCategoryData], // Add the subcategory data
                      id: issueId,
                      Hideshow: false,
                      issue_override: false,
                    },
                  };

                  // console.log(uniqueCategoryMap[issueId], uniqueCategoryMap, "subCategoryData subCategoryData");
                } else {
                  const subcategoryExists = uniqueCategoryaddedscope[
                    issueId
                  ].categoryname.subcategorydata.some(
                    (existingSubcategory) =>
                      existingSubcategory.id === subCategoryData.id,
                  );

                  if (!subcategoryExists) {
                    // Add the new subcategory to the subcategorydata array
                    uniqueCategoryaddedscope[
                      issueId
                    ].categoryname.subcategorydata.push(subCategoryData);
                  }
                }

                return acc;
              },
              [],
            );

          // const formatteaddedcategorydata = Object.values(uniqueCategoryaddedscope)

          // const formattedCategoryDatalist = state.CategoryListed.CategoryDatas.map((cat) => cat.id);

          // const formatteaddedcategorydata = Object.values(uniqueCategoryaddedscope).map((category) => {
          //   const categoryExists = formattedCategoryDatalist.includes(category.categoryname.id);

          //   console.log(categoryExists, "categoryExistscategoryExists");

          //   return {
          //     ...category.categoryname,
          //     displaykey: !categoryExists, // Set displaykey based on whether the category exists
          //   };
          // });

          const uniqueCategoryIds = Object.keys(uniqueCategoryMap); // Extract IDs from uniqueCategoryMap

          const formatteaddedcategorydata = Object.values(
            uniqueCategoryaddedscope,
          ).map((category) => {
            // Check existence based on uniqueCategoryMap
            const categoryExists = uniqueCategoryIds.includes(
              category.categoryname.id,
            );

            const formattedCategory = formattedCategoryData.find(
              (item) => item.categoryname.id === category.categoryname.id,
            );

            console.log(
              categoryExists,
              "categoryExists for category ID:",
              formattedCategoryData,
              category.categoryname.id,
            );
            console.log(
              formattedCategory?.categoryname.subcategorydata,
              "pASPOAISopAISAOPSiPOASIAOPSIOASI",
            );

            return {
              // ...category.categoryname,
              // displaykey: !categoryExists, // Set displaykey based on whether the category exists in uniqueCategoryMap
              // categoryname: {
              //   ...category.categoryname,
              //   displaykey: !categoryExists, // Set displaykey based on whether the category exists in uniqueCategoryMap
              //   Hideshow: !categoryExists ? true : category.categoryname.Hideshow,
              //   issue_override: !categoryExists ? true : category.categoryname.issue_override,
              //   subcategorydata: !categoryExists
              //     ? category.categoryname.subcategorydata.map((item) => ({
              //         ...item,
              //         fieldsAdded: true, // Adjust subcategory data fields when categoryExists is true
              //       }))
              //     : category.categoryname.subcategorydata,
              // },

              categoryname: {
                ...category.categoryname, // Spread current category details
                displaykey: !categoryExists, // Set displaykey based on existence
                Hideshow:
                  categoryExists == true
                    ? (formattedCategory?.categoryname.Hideshow ?? false)
                    : category.categoryname.Hideshow, // Use formattedCategoryData if categoryExists is false
                issue_override:
                  categoryExists == true
                    ? (formattedCategory?.categoryname.issue_override ?? false)
                    : category.categoryname.issue_override, // Use formattedCategoryData if categoryExists is false
                subcategorydata: categoryExists
                  ? (formattedCategory?.categoryname.subcategorydata.map(
                    (item) => ({
                      ...item,
                      // fieldsAdded: true, // Ensure fieldsAdded is true for the imported data
                      fieldsAdded: false,
                    }),
                  ) ?? [])
                  : category.categoryname.subcategorydata.map((item) => ({
                    ...item,
                    // fieldsAdded: false, // Retain current data for existing categories
                    fieldsAdded: false,
                  })),
              },
            };
          });

          console.log(
            formattedCategoryData,
            "formattedCategoryData oaisdusa dpoasd",
            formatteaddedcategorydata,
            Object.values(formatteaddedcategorydata),
          );

          // setCategoryFields(formattedCategoryData);

          setCategoryFields(formatteaddedcategorydata);
        } else if (state.SubCategoryListed.SubcategoryDatas.length == 0) {
          const uniqueCategoryaddedscope = {};

          const formattedaddedscopeData =
            state.SubCategorySlicedatas.BranchSubcategorylisted.reduce(
              (acc, item) => {
                const issueId = item.issue_category_id?.id; // Extract the issue_id.id

                const subCategoryData = {
                  id: item?.id, // Subcategory ID
                  name: item.name, // Use name based on condition
                  Priority: {
                    value: item?.Priority,
                    label:
                      item?.Priority === "0"
                        ? "Low"
                        : item?.Priority === "1"
                          ? "Medium"
                          : item?.Priority === "2"
                            ? "High"
                            : "",
                  },
                  issue_id: issueId, // Actual category ID
                  is_active: {
                    value: item?.is_active,
                    label: item?.is_active ? "Active" : "In active",
                  },
                  issue_sub_id: item?.id,
                  categoryname: item.issue_category_id?.name,
                  fieldsAdded: false,
                  issue_override: false,
                };

                // Check if the issue_id.id is already present in the map
                if (!uniqueCategoryaddedscope[issueId]) {
                  uniqueCategoryaddedscope[issueId] = {
                    categoryname: {
                      name: item.issue_category_id?.name,
                      subcategorydata: [subCategoryData], // Add the subcategory data
                      id: issueId,
                      Hideshow: false,
                      issue_override: false,
                    },
                  };

                  // console.log(uniqueCategoryMap[issueId], uniqueCategoryMap, "subCategoryData subCategoryData");
                } else {
                  const subcategoryExists = uniqueCategoryaddedscope[
                    issueId
                  ].categoryname.subcategorydata.some(
                    (existingSubcategory) =>
                      existingSubcategory.id === subCategoryData.id,
                  );

                  if (!subcategoryExists) {
                    // Add the new subcategory to the subcategorydata array
                    uniqueCategoryaddedscope[
                      issueId
                    ].categoryname.subcategorydata.push(subCategoryData);
                  }
                }

                return acc;
              },
              [],
            );

          const formatteaddedcategorydata = Object.values(
            uniqueCategoryaddedscope,
          ).map((category) => {
            // const categoryExists = uniqueCategoryIds.includes(category.categoryname.id);

            // const formattedCategory = formattedCategoryData.find(
            //   (item) => item.categoryname.id === category.categoryname.id
            // );

            return {
              // categoryname: {
              //   ...category.categoryname, // Spread current category details
              //   displaykey: !categoryExists, // Set displaykey based on existence
              //   Hideshow: categoryExists == true
              //     ? formattedCategory?.categoryname.Hideshow ?? false
              //     : category.categoryname.Hideshow, // Use formattedCategoryData if categoryExists is false
              //   issue_override: categoryExists == true
              //     ? formattedCategory?.categoryname.issue_override ?? false
              //     : category.categoryname.issue_override, // Use formattedCategoryData if categoryExists is false
              //   subcategorydata: categoryExists
              //     ? formattedCategory?.categoryname.subcategorydata.map((item) => ({
              //       ...item,
              //       // fieldsAdded: true, // Ensure fieldsAdded is true for the imported data
              //       fieldsAdded: false,

              //     })) ?? []
              //     : category.categoryname.subcategorydata.map((item) => ({
              //       ...item,
              //       // fieldsAdded: false, // Retain current data for existing categories
              //       fieldsAdded: false,

              //     })),
              // },

              categoryname: {
                ...category.categoryname, // Spread current category details
                displaykey: true, // Set displaykey based on existence
                Hideshow: category.categoryname.Hideshow,
                issue_override: false,
                subcategorydata: category.categoryname.subcategorydata.map(
                  (item) => ({
                    ...item,
                    fieldsAdded: false,
                  }),
                ),
              },
            };
          });

          console.log(
            formatteaddedcategorydata,
            state.CategoryListed.CategoryDatas,
            "formattedCategoryData oaisdusa dpoasd",
            formattedaddedscopeData,
            formatteaddedcategorydata,
            Object.values(formatteaddedcategorydata),
          );

          setCategoryFields(formatteaddedcategorydata);
        }
      } else if (data.scope_ids.length == 0) {
        setCategoryFields([]);
      }
    } else {
      if (data.scope_ids.length > 0) {
        if (
          Array.isArray(state.SubCategoryListed?.SubcategoryDatas) &&
          state.SubCategoryListed?.SubcategoryDatas.length > 0
        ) {
          const formattedData = state.SubCategoryListed?.SubcategoryDatas.map(
            (item) => {
              const subCategoryData = {
                id: item.id,
                name: item.name, // If no match, leave the name empty
                Priority: {
                  value: item.Priority,
                  label:
                    item?.Priority === "0"
                      ? "Low"
                      : item.Priority === "1"
                        ? "Medium"
                        : item.Priority === "2" && "High",
                },
                issue_id: item?.issue_category_id?.id,
                is_active: {
                  value: item.is_active,
                  label: item.is_active ? "Active" : "In active",
                },
                issue_sub_id: item.id,
              };

              return {
                subcategorydata: subCategoryData,
                Hideshow: false,
              };
            },
          );

          setCategoryFields(formattedData);
        }
      }
      // else {
      //   setCategoryFields([]);

      // }
    }
    // }, [state.SubCategoryListed?.SubcategoryDatas, EditId,]);
  }, [
    state.SubCategoryListed.SubcategoryDatas,
    EditId,
    state.SubCategorySlicedatas.BranchSubcategorylisted,
    data.scope_ids,
    state.CategoryListed.CategoryDatas,
  ]);

  ///---user--manager-----------
  useEffect(() => {
    if (
      EditId != undefined &&
      data.state_id != undefined &&
      data.state_id != null &&
      data.state_id != "" &&
      data.region_id != undefined &&
      data.region_id != null &&
      data.region_id != "" &&
      data.zone_id != undefined &&
      data.zone_id != null &&
      data.zone_id != "" &&
      state.BranchRetrieve.BranchesRetrieve != undefined
    ) {
      const payload = {
        search: SearchedVal.usersearh,
        page_size: 20,
        page: 1,
        white_collar: true,
        state: data.state_id,
        region: data.region_id,
        zone: data.zone_id,
      };
      dispatch(setUserActions(payload));
    } else if (EditId == undefined) {
      const payload = {
        search: SearchedVal.usersearh,
        page_size: 20,
        page: 1,
        white_collar: true,
        state: data.state_id,
        region: data.region_id,
        zone: data.zone_id,
      };
      dispatch(setUserActions(payload));
    }
  }, [SearchedVal.usersearh, data.state_id, data.region_id, data.zone_id]);

  useEffect(() => {
    if (state.Usergetlists.UserList != undefined) {
      let ObjectArrayFormager = [];
      state.Usergetlists.UserList.forEach((element) => {
        ObjectArrayFormager.push({
          value: element.id,
          label: element.first_name,
        });
      });
      setManagerOptions(ObjectArrayFormager);
    }
  }, [state.Usergetlists.UserList, SearchedVal.usersearh]);

  useEffect(() => {
    if (state.Usergetlists.UserList !== undefined) {
      let ObjectArrayFormager = [];
      state.Usergetlists.UserList.forEach((element) => {
        if (
          !data.l1_user.includes(String(element.id)) &&
          !data.l2_user.includes(String(element.id)) &&
          !data.l3_user.includes(String(element.id))
        ) {
          ObjectArrayFormager.push({
            value: element.id,
            label: capitalizeEachWord(element.first_name.toLowerCase()),
            role: capitalizeEachWord(element.user_role?.role.toLowerCase()),
          });
        }
      });

      setLoneOptions(ObjectArrayFormager);
    }
  }, [
    state.Usergetlists.UserList,
    SearchedVal.usersearh,
    data.l1_user,
    data.l2_user,
    data.l3_user,
  ]);

  const HandletheSubcategory = (index, datas) => {
    const updatedFields = [...CategoryFields]; // Copy the state

    // Find the existing category
    const existingCategory = updatedFields[index];

    if (existingCategory) {
      // Initialize subcategorydata if it doesn't exist
      if (!Array.isArray(existingCategory.categoryname.subcategorydata)) {
        existingCategory.categoryname.subcategorydata = [];
      }

      const issueId =
        datas?.categoryname?.subcategorydata?.[0]?.issue_id || null;

      // Add a new subcategory to the subcategorydata array
      existingCategory.categoryname.subcategorydata.push({
        name: "", // Placeholder for subcategory name
        Priority: {},
        is_active: {},
        id: datas?.categoryname.subcategorydata?.id || null,
        issue_id: issueId, // Dynamically fetched issue_id
        // issue_id: datas?.categoryname.subcategorydata?.issue_id || null, // Category ID
        issue_sub_id: datas?.categoryname.subcategorydata?.issue_sub_id || null, // Subcategory Issue ID,
        fieldsAdded: true,
      });
    }

    // Update the state with the modified fields
    setCategoryFields(updatedFields);
  };

  const Handlethshow = (categorydat, index, Valuess) => {
    const updatedFields = [...CategoryFields]; // Create a copy of the CategoryFields array

    // Update the Hideshow property to true
    updatedFields[index].categoryname.Hideshow = Valuess;

    console.log(updatedFields[index], "Updated categorydat"); // Log the updated object at the given index

    // Update the state with the modified array
    setCategoryFields(updatedFields);
  };

  const handleInputscope = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      ScopeSearch: Val,
    });
  };

  useEffect(() => {
    if (state.ScopeGettheDatalist?.ScopeRecords != undefined) {
      let objectArray = [];
      state.ScopeGettheDatalist.ScopeRecords.forEach((element) => {
        objectArray.push({ value: element.id, label: element.scope_name });
      });

      setScopeoptions(objectArray);
    }
  }, [state.ScopeGettheDatalist?.ScopeRecords, ScopeSearch]);

  ///------------REgion------------------
  useEffect(() => {
    if (data.state_id != undefined && data.state_id != "") {
      const payloads = {
        search: SearchedVal.regionSearch,
        page_size: "",
        page: 1,
        state: data.state_id,
        counts: 1,
      };
      dispatch(setRegionActions(payloads));
      setRegion(state.regioncall.RegionDat);
    }
  }, [data.state_id, SearchedVal.regionSearch]);
  ///-----------Client----------------
  useEffect(() => {
    const payloads = {
      search: "",
      page_size: 10,
      page: 1,
      project_number: "",
      pre_area: "",
      // month: Datamonth.month,
      // year: Datamonth.year,
    };
    dispatch(SetClientActions(payloads));
    setClient(state.ClientList.ClientLists);
  }, []);

  useEffect(() => {
    if (state.ClientList.ClientLists != undefined) {
      setClient(state.ClientList.ClientLists.client_name);
    }
  }, [state.ClientList.ClientLists]);
  //--------------------------Zone---
  useEffect(() => {
    if (data.region_id != undefined && data.region_id != "") {
      const payloads = {
        search: SearchedVal.zoneSearch,
        page_size: "",
        page: 1,
        region_id: data.region_id,
        counts: 1,
      };
      dispatch(setZoneActions(payloads));
      setZone(state.ZonePart.Zone);
    }
  }, [data.region_id, SearchedVal.zoneSearch]);

  useEffect(() => {
    if (state.GeoState.State.id != undefined) {
      setState(state.GeoState.State.state_name);
    }
  }, [state.GeoState.State]);
  ///--------------------State----------------------
  useEffect(() => {
    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState, SearchedVal.stateSearch]);
  ///----------------------REgion-----------
  useEffect(() => {
    setRegion(state.regioncall.RegionDat);
    if (data.state_id != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name,
          isDisabled: true,
        });
      });
      setOptions2(objectArray);
    }
  }, [
    data.state_id,
    state.regioncall.RegionDat,
    SearchedVal.regionSearch,
    SearchedVal.zoneSearch,
  ]);
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined && data.state_id != "") {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name,
          isDisabled: false,
        });
      });
      setOptions2(objectArray);
    }
  }, [
    state.regioncall.RegionDat,
    SearchedVal.regionSearch,
    SearchedVal.zoneSearch,
  ]);
  ///----------Clients-------------
  useEffect(() => {
    setClient(state.ClientList.ClientLists);
    if (state.ClientList.ClientLists != undefined) {
      let objectArray = [];
      state.ClientList.ClientLists.forEach((element) => {
        objectArray.push({ value: element.id, label: element.client_name });
      });

      setOptions3(objectArray);
    }
  }, [state.ClientList]);
  ///-------------Zone--------------
  useEffect(() => {
    setZone(state.ZonePart.Zone);
    if (data.region_id != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        if (element.zone_name != null) {
          objectArray.push({
            value: element.id,
            label: element.zone_name.toUpperCase(),
            isDisabled: true,
          });
        }
      });
      setOptions4(objectArray);
    }
    if (state.ZonePart.Zone != undefined && data.region_id != "") {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        if (element.zone_name != null) {
          objectArray.push({
            value: element.id,
            label: element.zone_name.toUpperCase(),
            isDisabled: false,
          });
        }
      });
      setOptions4(objectArray);
    }
  }, [data.region_id, state.ZonePart.Zone, SearchedVal.zoneSearch]);

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setMuliselect3([]);
    if (data.state_id != "" || data.state_id != undefined) {
      setMuliselect1(selectedVal);

      setData({
        ...data,
        region_id: selectedVal.value,
        zone_id: "",
      });
    }
    if (data.state_id == "") {
      setRegionError();
      setStateError("*state is required");
    }
  };

  ////------------___CLient
  const handleClients = (selectedVal) => {
    setMuliselect2(selectedVal);
    setData({
      ...data,
      client_id: selectedVal.value,
    });
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    setMuliselect3(selectedVal);
    setData({
      ...data,
      zone_id: selectedVal.value,
    });
  };
  const handleClose = () => {
    window.location.href = "/clientbranch";
  };
  const HandleChanges = (e) => {
    if (e.target.name == "total_permissions") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value.slice(0, 2),
      });

      // setData((prev) => {
      //   return {
      //     ...prev,
      //     [e.target.name]: e.target.value,
      //   };
      // });
    }

    if (e.target.name == "casual_leave") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value,
      });

      // setData((prev) => {
      //   return {
      //     ...prev,
      //     [e.target.name]: e.target.value,
      //   };
      // });
    }
    if (e.target.name == "wbs_element") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value.slice(0, 60),
      });
    }

    if (e.target.name == "personal_leave") {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value,
      });

      // setData((prev) => {
      //   return {
      //     ...prev,
      //     [e.target.name]: e.target.value,
      //   };
      // });
    } else {
      const { name, value } = e.target;

      setData({
        ...data,
        [name]: value,
      });
    }
  };
  const inputRef = useRef();
  const preventZoom = (event) => {
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    const filtered = paste.replace(/[^0-9]/g, "");
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } });
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  const preventScrollnumber = (e) => {
    e.preventDefault();
  };
  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  const HandleTheleaveType = (va) => {
    setLeaveTypeErr("");
    setLeaveMulitiValues(va);
    let valuess = [];
    va.map((item) => {
      valuess.push(item.value);
    });

    setData({
      ...data,
      leave_types: valuess,
    });
  };
  useEffect(() => {
    const payloads = {
      search: searchleave,
      page_size: 20,
      page: 1,
    };
    dispatch(SetLeaveTypeActions(payloads));
  }, [searchleave]);

  useEffect(() => {
    if (state.LeaveTypeList.LeaveTypeList != undefined) {
      let objectArray = [];
      state.LeaveTypeList.LeaveTypeList.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.leave_type.toUpperCase(),
        });
      });
      setLeaveOptions(objectArray);
    }
  }, [state.LeaveTypeList.LeaveTypeList, searchleave]);

  ///----Map---Location----Changes----
  const LocationChanges = (event) => {
    setMapCenter({
      ...mapCenter,
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
  };
  ///---By----Searching----
  const SearchedLoc = (map) => {
    setMapCenter({
      ...mapCenter,
      lat: map.lat,
      lng: map.lng,
    });
  };

  const HandleClick = () => {
    if (EditId == undefined) {
      var a = 0;
      if (data.client_name == "") {
        setClientNaaErr("*Branch  is required");
        a = 1;
      }
      if (data.scope_ids.length == 0) {
        setScopeErr("*Scope  is required");
        a = 1;
      }
      if (!data.organization_id || data.organization_id == " ") {
        setorganizationerr("*Organization  is required");
        a = 1;
      }

      // if (data.description == "") {
      //   setDescriptionError("*Description is required");
      //   a = 1;
      // }

      if (data.client_id == "") {
        setClientError("*Client  is required");
        a = 1;
      }
      if (data.region_id == "") {
        setRegionError("*Region is required");
        a = 1;
      }
      if (data.state_id == "") {
        setStateError("*State is required");
        a = 1;
      }
      if (data.zone_id == "") {
        setZoneError("*Zone is required");
        a = 1;
      }

      if (data.Address == "") {
        setAddressErr("*Address is required");
        a = 1;
      }
      // if (data.ph == "") {
      //   a = 1;
      //   setPhoneError("*Phone number is required");
      // }
      if (ticketingRadioChecked == true) {
        inputFields.map((item) => {
          if (
            item.first_name == "" ||
            item.first_name == null ||
            item.first_name == undefined
          ) {
            setcontactNameerr("*Name is required");
            a = 1;
          }

          if (
            item.phone_number == "" ||
            item.phone_number == null ||
            item.phone_number == undefined
          ) {
            setContactPhErr("*Phone number is required");
            a = 1;
          }
          if (item.phone_number != "" && item.phone_number.length < 10) {
            a = 1;
            setContactPhErr("*Phone number should not less than 10 digits");
          }

          if (
            item.password == "" ||
            item.password == null ||
            item.password == undefined
          ) {
            setPasserr("*Password is required");
            a = 1;
          }

          if (item.email != "" && !validator.isEmail(item.email)) {
            setcontactEmailerr("*Enter valid mail id");
            a = 1;
          }
          if (item.email == "") {
            setcontactEmailerr("*Email is required");
            a = 1;
          }
        });
        if (data.l1_time_type === "") {
          setL1TimeTypeErr("*Type is required");
          a = 1;
        }

        if (data.l2_time_type === "") {
          setL2TimeTypeErr("*Type is required");
          a = 1;
        }

        if (data.l3_time_type === "") {
          setL3TimeTypeErr("*Type is required");
          a = 1;
        }

        if (data.l1_user_TAT === "") {
          setL1UserTATErr("*TAT is required");
          a = 1;
        }

        if (data.l2_user_TAT === "") {
          setL2UserTATErr("*TAT is required");
          a = 1;
        }

        if (data.l3_user_TAT === "") {
          setL3UserTATErr("*TAT is required");
          a = 1;
        }

        if (
          data.l1_user.length == 0 ||
          data.l1_time_type == "" ||
          data.l1_user_TAT == ""
        ) {
          setLevelOnePersonst(true);
        }

        if (
          data.l2_user.length == 0 ||
          data.l2_time_type == "" ||
          data.l2_user_TAT == ""
        ) {
          setLevelTwoPersonst(true);
        }

        if (
          data.l3_user.length == 0 ||
          data.l3_time_type == "" ||
          data.l3_user_TAT == ""
        ) {
          setLevelThreePersonst(true);
        }

        if (data.l1_user.length == 0) {
          setLoneuserserr("*L1 Persons are requried");
          a = 1;
        }

        if (data.l2_user.length == 0) {
          setLTwoUserserr("*L2 Persons are requried");
          a = 1;
        }

        if (data.l3_user.length == 0) {
          setLthreeUserserr("*L3 Persons are requried");
          a = 1;
        }
      }

      if (
        data?.attendance_features != "" &&
        data?.attendance_features != null
      ) {
        if (
          data.attendance_features != "0" &&
          data.attendance_features != "1"
        ) {
          // if(data?.geo_location_radius == null ||  data?.geo_location_radius == ""){
          if (!data?.geo_location_radius || data?.geo_location_radius == "0") {
            setradiuse_err("*Attendance radius is required");
            a = 1;
          } else {
            if (
              data?.geo_location_radius != "" &&
              data?.geo_location_radius != null &&
              (data?.geo_location_radius < 10 ||
                data?.geo_location_radius > 50000)
            ) {
              setradiuse_err(
                "*Attendance radius must be between 10 m and 50,000 m",
              );
              a = 1;

              // }
            }
          }
        }
      }

      if (Attendance_verified == true) {
        if (
          data.attendance_features == "" ||
          data.attendance_features == null
        ) {
          setAttendancesErr("*Attendance Feature Type  is required");
          a = 1;
        }
      }

      // if (data.ph != "" && data.ph.length < 10) {
      //   a = 1;
      //   setPhoneError("*Phone number should not less than 10 digits");
      // }

      // if (data.Email != "" && !validator.isEmail(data.Email)) {
      //   setEmailErr("*Enter valid mail id");
      //   a = 1;
      // }
      // if (data.Email == "") {
      //   setEmailErr("*Email Id is required");
      //   a = 1;
      // }

      // if (data.total_permissions == "") {
      //   setShiftError("*shift permission  is  required");
      //   a = 1;
      // }

      // if (data.supervisor_ids.length == 0) {
      //   setReportingErr("*Reporting Person is requried");
      //   a = 1;
      // }

      if (leaveRadioChecked == true) {
        if (data.leave_types.length == 0) {
          setLeaveTypeErr("*Leave type is requried");
          a = 1;
        }
        if (data.extra_leave === "" && data.extra_leave.length !== 9) {
          setLeaveExtracErr("Leave (Per Month) is required");
          a = 1;
        } else {
          setLeaveExtracErr(""); // Clear error if value is not an empty string
        }

        if (data.personal_leave === "" && data.personal_leave.length !== 9) {
          setPersonslErr("*Personal leave (Per Month) is required");
          a = 1;
        } else {
          setPersonslErr(""); // Clear error if value is not an empty string
        }

        if (data.casual_leave === "" && data.casual_leave.length !== 9) {
          setCasualErr("Casual Leave (Per Month) is required");
          a = 1;
        } else {
          setCasualErr(""); // Clear error if value is not an empty string
        }
      }
      if (data.extra_leave !== "" && data.extra_leave.length > 9) {
        setLeaveExtracErr("Leave should not exceed 9 number");
        a = 1;
      }

      if (data.personal_leave != "" && data.personal_leave.length > 9) {
        setPersonslErr("*Personal Leave should not exceed 9 number");
        a = 1;
      }

      if (data.casual_leave != "" && data.casual_leave.length > 9) {
        setCasualErr("*Casual Leave should not exceed 9 Numbers");
        a = 1;
      }
      // if (data.leave_valid_until == "") {
      //   setLeaveErr("*Leave valid  is  required");
      //   a = 1;
      // }
      // if (data.permission_valid_until == "") {
      //   setPermissionErr("*permission valid  is  required");
      //   a = 1;
      // }
      // if (data.wbs_element == "") {
      //   setWbsElemeErr("*Wbs is reuried");
      //   a = 1;
      // }

      // if (data.wbs_element != "" && data.wbs_element.length > 60) {
      //   setWbsElemeErr("*Wbs Element should not exit");
      //   a = 1;
      // }

      // if (data.manager_ids == []) {
      //   a = 1;
      //   setMnagerErr("*Manager Access list is required");
      // }

      if (a == 0 && ErrorInde == 0) {
        const newEntry = { updated: true };
        const result = {
          ...TablePositionPersist.clientBranchPage,
          ...newEntry,
        };

        dispatch(
          setTablePositionPersist({
            data: result,
            pageName: "clientBranchPage",
          }),
        );

        const isAllFieldsEmpty = inputFields.every(
          (item) =>
            !item.first_name &&
            !item.phone_number &&
            !item.password &&
            !item.email,
        );
        const payload = {
          data: data,
          has_leave: leaveRadioChecked,
          currentPage: 1,
          longitude: String(mapCenter.lng),
          latitude: String(mapCenter.lat),
          // month: Datamonth.month,
          // year: Datamonth.year,
          CreatedData:
            ticketingRadioChecked == true
              ? {
                client_name: data.client_name,
                // short_description: data.description,
                short_description: null,
                // email: data.Email,
                email: null,
                address: data.Address,
                phone_number: null,
                // phone_number: data.ph,
                client_id: data.client_id,
                state_id: data.state_id,
                region_id: data.region_id,
                zone_id: data.zone_id,
                latitude: String(mapCenter.lat),
                longitude: String(mapCenter.lng),
                wbs_element: data.wbs_element,
                // total_permissions: Number(payload.payload.data.total_permissions),
                personal_leave: Number(data.personal_leave),

                casual_leave: Number(data.casual_leave),
                // leave_valid_until: payload.payload.data.leave_valid_until,
                // permission_valid_until: payload.payload.data.permission_valid_until,
                supervisor_ids: data.supervisor_ids,
                leave_types: data.leave_types,
                extra_leave: Number(data.extra_leave),
                has_leave: leaveRadioChecked,
                l1_user: data.l1_user,
                l2_user: data.l2_user,
                l3_user: data.l3_user,
                contact_persons: inputFields,
                l1_time_type: data.l1_time_type,
                l2_time_type: data.l2_time_type,
                l3_time_type: data.l3_time_type,
                l1_user_TAT: Number(data.l1_user_TAT),
                l2_user_TAT: Number(data.l2_user_TAT),
                l3_user_TAT: Number(data.l3_user_TAT),
                scope_ids: data.scope_ids,
                issue_override: false,
                organization_id: data.organization_id,
                rm_ids: data.rm_ids,
                pm_ids: data.pm_ids,
                vh_ids: data.vh_ids,
                product_code: data?.product_code || "",
                division_level: toDivisionLevelList(data?.division_level),
                program_code: data?.program_code || "",
                project_code: data?.project_code || "",
                client_code: data?.client_code || "",
                division_code: data?.division_code || "",
                division_name: data?.division_name || "",

                geo_location_radius: data?.geo_location_radius
                  ? Number(data?.geo_location_radius)
                  : 0,
                attendance_features: data?.attendance_features,
                is_attendance_active: Attendance_verified,
              }
              : {
                client_name: data.client_name,
                short_description: null,
                email: null,
                address: data.Address,
                phone_number: null,
                client_id: data.client_id,
                state_id: data.state_id,
                region_id: data.region_id,
                zone_id: data.zone_id,
                latitude: String(mapCenter.lat),
                longitude: String(mapCenter.lng),
                wbs_element: data.wbs_element,
                personal_leave: Number(data.personal_leave),

                casual_leave: Number(data.casual_leave),
                supervisor_ids: data.supervisor_ids,
                leave_types: data.leave_types,
                extra_leave: Number(data.extra_leave),
                has_leave: leaveRadioChecked,
                scope_ids: data.scope_ids,
                issue_override: false,
                // l1_user: [],
                // l2_user: [],
                // l3_user: [],
                // contact_persons: [],
                // l1_time_type: null,
                // l2_time_type: null,
                // l3_time_type: null,
                l1_user: data.l1_user,
                l2_user: data.l2_user,
                l3_user: data.l3_user,
                // contact_persons: [],
                contact_persons: isAllFieldsEmpty ? [] : inputFields,
                l1_time_type: data.l1_time_type,
                l2_time_type: data.l2_time_type,
                l3_time_type: data.l3_time_type,
                l1_user_TAT: Number(data.l1_user_TAT),
                l2_user_TAT: Number(data.l2_user_TAT),
                l3_user_TAT: Number(data.l3_user_TAT),
                // l1_user_TAT: null,
                // l2_user_TAT: null,
                // l3_user_TAT: null,
                organization_id: data.organization_id,

                rm_ids: data.rm_ids,
                pm_ids: data.pm_ids,
                vh_ids: data.vh_ids,
                product_code: data?.product_code || "",
                division_level: toDivisionLevelList(data?.division_level),
                program_code: data?.program_code || "",
                project_code: data?.project_code || "",
                client_code: data?.client_code || "",
                division_code: data?.division_code || "",
                division_name: data?.division_name || "",
                geo_location_radius: data?.geo_location_radius
                  ? Number(data?.geo_location_radius)
                  : 0,
                attendance_features: data?.attendance_features,
                is_attendance_active: Attendance_verified,
              },
          Funcations: () => {
            // Your function logic here
            console.log("Function called");
            // navigator("/clientbranch")
            setShow(false);
          },
        };
        dispatch(setClientBranchCreateActions(payload));
      }
    }
  };
  console.log(data?.geo_location_radius, "data?.geo_location_radius");

  const HandleEdit = () => {
    var a = 0;
    if (EditId != undefined) {
      if (data.client_name == "") {
        setClientNaaErr("*Branch is required");
        a = 1;
      }
      if (data.scope_ids.length == 0) {
        setScopeErr("*Scope  is required");
        a = 1;
      }
      if (!data.organization_id || data.organization_id == " ") {
        setorganizationerr("*Organization  is required");
        a = 1;
      }
      // if (data.description == null || data.description == "") {
      //   setDescriptionError("*Description is required");
      //   a = 1;
      // }
      if (data.client_id == "") {
        setClientError("*Client  is required");
        a = 1;
      }
      if (data.region_id == "") {
        setRegionError("*Region is required");
        a = 1;
      }
      if (data.state_id == "") {
        setStateError("*State is required");
        a = 1;
      }
      if (data.zone_id == "") {
        setZoneError("*Zone is required");
        a = 1;
      }

      if (
        data.Email != "" &&
        data.Email != null &&
        !validator.isEmail(data.Email)
      ) {
        setEmailErr("*Enter valid mail id");
        a = 1;
      }

      //               if(data?.attendance_features != "" && data?.attendance_features != null){
      //       if(data.attendance_features !="0" &&  data.attendance_features != "1"){
      //     if(data?.geo_location_radius == null ||  data?.geo_location_radius == ""){
      //       if(!data?.geo_location_radius || data?.geo_location_radius =="0"){
      // setradiuse_err("*Attendance radius is required");
      //             a = 1;

      //       }else {
      //           if (data?.geo_location_radius != ""&& data?.geo_location_radius != null  && (data?.geo_location_radius < 10 || data?.geo_location_radius > 50000)) {
      // setradiuse_err("*Attendance radius must be between 10 m and 50,000 m");
      //             a = 1;

      //     }

      //   }

      //     }
      //   }
      //   }

      if (
        data?.attendance_features !== "" &&
        data?.attendance_features !== null
      ) {
        if (
          data?.attendance_features !== "0" &&
          data?.attendance_features !== "1"
        ) {
          // if (data?.geo_location_radius == null || data?.geo_location_radius == "") {
          if (!data?.geo_location_radius || data?.geo_location_radius === "0") {
            setradiuse_err("Attendance radius is required");
            a = 1;
          } else {
            // if (data?.geo_location_radius < 10 || data?.geo_location_radius > 50000) {
            //   setradiuse_err("Attendance radius must be between 10 m and 50,000 m");
            //   a = 1;
            // }
            if (
              Number(data?.geo_location_radius) < 10 ||
              Number(data?.geo_location_radius) > 50000
            ) {
              setradiuse_err(
                "Attendance radius must be between 10 m and 50,000 m",
              );
              a = 1;
            }
          }
        }
        // }
      }

      if (Attendance_verified == true) {
        if (
          data.attendance_features == "" ||
          data.attendance_features == null
        ) {
          setAttendancesErr("*Attendance Feature Type  is required");
          a = 1;
        }
      }
      // if (data.supervisor_ids.length == 0) {
      //   setReportingErr("*Reporting Person is requried");
      //   a = 1;
      // }
      if (leaveRadioChecked == true) {
        if (data.leave_types.length == 0) {
          setLeaveTypeErr("*Leave type is requried");
          a = 1;
        }
        if (data.extra_leave === "" && data.extra_leave.length !== 9) {
          setLeaveExtracErr("Leave (Per Month) is required");
          a = 1;
        } else {
          setLeaveExtracErr(""); // Clear error if value is not an empty string
        }

        if (data.personal_leave === "" && data.personal_leave.length !== 9) {
          setPersonslErr("*Personal leave (Per Month) is required");
          a = 1;
        } else {
          setPersonslErr(""); // Clear error if value is not an empty string
        }

        if (data.casual_leave === "" && data.casual_leave.length !== 9) {
          setCasualErr("Casual Leave (Per Month) is required");
          a = 1;
        } else {
          setCasualErr(""); // Clear error if value is not an empty string
        }
      }

      // if (data.ph != "" && data.ph.length < 10) {
      //   a = 1;
      //   setPhoneError("*Phone number should not less than 10 digits");
      // }

      if (data.extra_leave !== "" && data.extra_leave.length > 9) {
        setLeaveExtracErr("Leave should not exceed 9 number");
        a = 1;
      }

      if (data.personal_leave != "" && data.personal_leave.length > 9) {
        setPersonslErr("*Personal Leave should not exceed 9 number");
        a = 1;
      }

      if (data.casual_leave != "" && data.casual_leave.length > 9) {
        setCasualErr("*Casual Leave should not exceed 9 Numbers");
        a = 1;
      }
      if (ticketingRadioChecked == true) {
        if (data.l1_user.length == 0) {
          setLoneuserserr("*L1 Persons are requried");
          a = 1;
        }

        if (data.l2_user.length == 0) {
          setLTwoUserserr("*L2 Persons are requried");
          a = 1;
        }

        if (data.l3_user.length == 0) {
          setLthreeUserserr("*L3 Persons are requried");
          a = 1;
        }
        if (data.l1_time_type === "" || data.l1_time_type == null) {
          setL1TimeTypeErr("*Type is required");
          a = 1;
        }

        if (data.l2_time_type === "" || data.l2_time_type == null) {
          setL2TimeTypeErr("*Type is required");
          a = 1;
        }
        if (data.l1_user_TAT === "" || data.l1_user_TAT == 0) {
          setL1UserTATErr("*TAT is required");
          a = 1;
        }

        if (data.l2_user_TAT === "" || data.l2_user_TAT == 0) {
          setL2UserTATErr("*TAT is required");
          a = 1;
        }

        if (data.l3_user_TAT === "" || data.l3_user_TAT == 0) {
          setL3UserTATErr("*TAT is required");
          a = 1;
        }

        if (data.l3_time_type === "" || data.l3_time_type == null) {
          setL3TimeTypeErr("*Type is required");
          a = 1;
        }
        if (
          data.l1_user.length == 0 ||
          data.l1_time_type == "" ||
          data.l1_time_type == null ||
          data.l1_user_TAT == "" ||
          data.l1_user_TAT == 0
        ) {
          setLevelOnePersonst(true);
        }

        if (
          data.l2_user.length == 0 ||
          data.l2_time_type == "" ||
          data.l2_time_type == null ||
          data.l2_user_TAT == "" ||
          data.l2_user_TAT == 0
        ) {
          setLevelTwoPersonst(true);
        }

        if (
          data.l3_user.length == 0 ||
          data.l3_time_type == "" ||
          data.l3_time_type == null ||
          data.l3_user_TAT == "" ||
          data.l3_user_TAT == 0
        ) {
          setLevelThreePersonst(true);
        }
      }
      // if (data.total_permissions == "") {
      //   setShiftError("*shift permission  is  required");
      //   a = 1;
      // }
      // if (data.wbs_element == "") {
      //   setWbsElemeErr("*Wbs is reuried");
      //   a = 1;
      // }
      // if (data.wbs_element != "" && data.wbs_element.length > 60) {
      //   setWbsElemeErr("*Wbs Element should not exit");
      //   a = 1;
      // }
      // if (data.manager_ids == []) {
      //   a = 1;
      //   setMnagerErr("*Manager Access list is required");
      // }

      if (a == 0 && ErrorInde == 0) {
        const newEntry = { updated: true };
        const result = {
          ...TablePositionPersist.clientBranchPage,
          ...newEntry,
        };

        dispatch(
          setTablePositionPersist({
            data: result,
            pageName: "clientBranchPage",
          }),
        );

        const payload = {
          data: data,
          has_leave: leaveRadioChecked,
          currentPage: currentPage,
          EditId: EditId,
          editdata:
            ticketingRadioChecked == true
              ? {
                client_name: data.client_name,
                // short_description: data.description,
                short_description: null,
                // email: data.Email,
                email: null,
                address: data.Address,
                phone_number: null,
                // phone_number: data.ph,
                client_id: data.client_id,
                state_id: data.state_id,
                region_id: data.region_id,
                zone_id: data.zone_id,
                latitude: String(mapCenter.lat),
                longitude: String(mapCenter.lng),
                wbs_element: data.wbs_element,
                // total_permissions: Number(payload.payload.data.total_permissions),
                personal_leave: Number(data.personal_leave),

                casual_leave: Number(data.casual_leave),
                // leave_valid_until: payload.payload.data.leave_valid_until,
                // permission_valid_until: payload.payload.data.permission_valid_until,
                supervisor_ids: data.supervisor_ids,
                leave_types: data.leave_types,
                extra_leave: Number(data.extra_leave),
                has_leave: leaveRadioChecked,
                l1_user: data.l1_user,
                l2_user: data.l2_user,
                l3_user: data.l3_user,
                // contact_persons: inputFields,
                l1_time_type: data.l1_time_type,
                l2_time_type: data.l2_time_type,
                l3_time_type: data.l3_time_type,
                l1_user_TAT: Number(data.l1_user_TAT),
                l2_user_TAT: Number(data.l2_user_TAT),
                l3_user_TAT: Number(data.l3_user_TAT),
                scope_ids: data.scope_ids,
                issue_override: false,
                organization_id: data.organization_id,
                rm_ids: data.rm_ids,
                pm_ids: data.pm_ids,
                vh_ids: data.vh_ids,
                product_code: data?.product_code || "",
                division_level: toDivisionLevelList(data?.division_level),
                program_code: data?.program_code || "",
                project_code: data?.project_code || "",
                client_code: data?.client_code || "",
                division_code: data?.division_code || "",
                division_name: data?.division_name || "",
                geo_location_radius: data?.geo_location_radius
                  ? Number(data?.geo_location_radius)
                  : 0,
                attendance_features: data?.attendance_features,
                is_attendance_active: Attendance_verified,
              }
              : {
                client_name: data.client_name,
                short_description: null,
                email: null,
                address: data.Address,
                phone_number: null,
                client_id: data.client_id,
                state_id: data.state_id,
                region_id: data.region_id,
                zone_id: data.zone_id,
                latitude: String(mapCenter.lat),
                longitude: String(mapCenter.lng),
                wbs_element: data.wbs_element,
                personal_leave: Number(data.personal_leave),

                casual_leave: Number(data.casual_leave),
                supervisor_ids: data.supervisor_ids,
                leave_types: data.leave_types,
                extra_leave: Number(data.extra_leave),
                has_leave: leaveRadioChecked,
                scope_ids: data.scope_ids,
                issue_override: false,
                // contact_persons: [],
                // l1_user: [],
                // l2_user: [],
                // l3_user: [],
                // l1_time_type: null,
                // l2_time_type: null,
                // l3_time_type: null,
                // l1_user_TAT: null,
                // l2_user_TAT: null,
                // l3_user_TAT: null,
                l1_user: data.l1_user,
                l2_user: data.l2_user,
                l3_user: data.l3_user,
                // contact_persons: inputFields,
                l1_time_type: data.l1_time_type,
                l2_time_type: data.l2_time_type,
                l3_time_type: data.l3_time_type,
                l1_user_TAT: Number(data.l1_user_TAT),
                l2_user_TAT: Number(data.l2_user_TAT),
                l3_user_TAT: Number(data.l3_user_TAT),
                organization_id: data.organization_id,
                rm_ids: data.rm_ids,
                pm_ids: data.pm_ids,
                vh_ids: data.vh_ids,
                program_code: data?.program_code || "",
                division_level: toDivisionLevelList(data?.division_level),
                product_code: data?.product_code || "",
                project_code: data?.project_code || "",
                client_code: data?.client_code || "",
                division_code: data?.division_code || "",
                division_name: data?.division_name || "",
                geo_location_radius: data?.geo_location_radius
                  ? Number(data?.geo_location_radius)
                  : 0,
                attendance_features: data?.attendance_features,
                is_attendance_active: Attendance_verified,
              },
          longitude: String(mapCenter.lng),
          latitude: String(mapCenter.lat),
          // month: state.ClientBranchIDs.monthANDYEA.month,
          // year: state.ClientBranchIDs.monthANDYEA.year,
          count: state.clientDetailsCall.clientBrancheditIDs,
          Funcations: () => {
            // Your function logic here
            console.log("Function called");
            setShow(false);
          },
        };

        dispatch(SetBranchEditActions(payload));
      }
    }
  };
  const Handlethecontactedit = (datas, ids) => {
    var Contactedit = 0;
    var Datapass = datas;
    if (
      datas.first_name == "" ||
      datas.first_name == null ||
      datas.first_name == undefined
    ) {
      setcontactNameerr("*Name is required");
      Contactedit = 1;
    }

    if (
      datas.phone_number == "" ||
      datas.phone_number == null ||
      datas.phone_number == undefined
    ) {
      setContactPhErr("*Phone number is required");
      Contactedit = 1;
    }
    if (datas.phone_number != "" && datas.phone_number.length < 10) {
      Contactedit = 1;
      setContactPhErr("*Phone number should not less than 10 digits");
    }

    // if (datas.password == "" || datas.password == null || datas.password == undefined) {
    //   setPasserr("*Password is required");
    //   Contactedit = 1;
    // }

    if (datas.email != "" && !validator.isEmail(datas.email)) {
      setcontactEmailerr("*Enter valid mail id");
      Contactedit = 1;
    }
    if (datas.email == "") {
      setcontactEmailerr("*Email is required");
      Contactedit = 1;
    }

    if (Contactedit == 0) {
      if (Datapass.password === "") {
        delete Datapass.password;
      }

      const payload = {
        data: datas,
        EditId: ids,
        Post: 2,
      };
      dispatch(setTheContacteitDetailsExportActions(payload));
    }
    console.log(datas, "datsdasdasdasdas", Datapass);
  };

  const HandlethecontactPost = (datas, ids, index) => {
    var Contactedit = 0;
    const updatedFields = [...inputFields]; // Clone the array for immutability
    const subcategoryData = updatedFields[index];

    var Datapass = {
      first_name: datas.first_name,
      phone_number: datas.phone_number,
      password: datas.password,
      email: datas.email,
      client_id: EditId,
    };
    if (
      datas.first_name == "" ||
      datas.first_name == null ||
      datas.first_name == undefined
    ) {
      setcontactNameerr("*Name is required");
      Contactedit = 1;
    }

    if (
      datas.phone_number == "" ||
      datas.phone_number == null ||
      datas.phone_number == undefined
    ) {
      setContactPhErr("*Phone number is required");
      Contactedit = 1;
    }
    if (datas.phone_number != "" && datas.phone_number.length < 10) {
      Contactedit = 1;
      setContactPhErr("*Phone number should not less than 10 digits");
    }

    if (
      subcategoryData.password == "" ||
      subcategoryData.password == null ||
      subcategoryData.password == undefined
    ) {
      setPasserr("*Password is required");
      Contactedit = 1;
    }

    if (datas.email != "" && !validator.isEmail(datas.email)) {
      setcontactEmailerr("*Enter valid mail id");
      Contactedit = 1;
    }
    if (datas.email == "") {
      setcontactEmailerr("*Email is required");
      Contactedit = 1;
    }

    if (Contactedit == 0) {
      // if (Datapass.password === '') {
      //   delete Datapass.password;
      // }

      const payload = {
        data: Datapass,
        Post: 1,
        EditId: "",
      };
      dispatch(setTheContacteitDetailsExportActions(payload));
      const updatedFields = [...inputFields]; // Clone the array for immutability
      const subcategoryData = updatedFields[index];
      console.log(subcategoryData, "sASASsubcategoryData");

      subcategoryData.password = ""; // Update name

      setInputFields(updatedFields);
    }
  };

  const handleClosepop = (e) => {
    // if (EditId != undefined) {
    //   setShow(false);
    //   dispatch(getClientEditActions(false));
    // } else if (EditId == undefined) {
    //   window.location.href = "/clientbranch";
    // }

    // Swal.fire({
    //   title: `Do you want to exit?`,
    //   // text: "You won't be able to revert this",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#f26639",
    //   cancelButtonColor: "#F69338",
    //   confirmButtonText: "Yes",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     if (EditId != undefined) {
    //       setData(createnewuser);
    //       setShow(false);
    //       dispatch(getClientEditActions(false));
    //     } else if (EditId == undefined) {
    //       // window.location.href = "/clientbranch";
    //       navigator("/clientbranch");
    //     }
    //   } else if (result.dismiss === Swal.DismissReason.cancel) {
    //     Swal.close();
    //   }
    // });
    Swal.fire({
      title: `Do you want to exit?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        if (EditId !== undefined) {
          setData(createnewuser);
          setShow(false);
          dispatch(getClientEditActions(false));
        } else {
          // navigator("/clientbranch");
          setShow(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  // const customStyles = {
  //   control: (base, state) => ({
  //     ...base,
  //     border: state.isFocused ? '2px solid #FF4500' : '1px solid #ddd',
  //     boxShadow: state.isFocused ? '0 0 5px rgba(255,69,0,0.5)' : 'none',
  //     borderRadius: '8px',
  //     display: 'flex',
  //     alignItems: 'center',
  //     padding: '5px',
  //   }),
  //   option: (base, state) => ({
  //     ...base,
  //     backgroundColor: state.isSelected ? '#FF4500' : state.isFocused ? '#FF7F50' : '#fff',
  //     color: state.isSelected || state.isFocused ? '#fff' : '#000',
  //     padding: '10px',
  //   }),
  //   singleValue: (base) => ({
  //     ...base,
  //     display: 'flex',
  //     alignItems: 'center',
  //   }),
  //   dropdownIndicator: (base) => ({
  //     ...base,
  //     color: '#FF4500',
  //   }),
  // };

  console.log(data, ticketingRadioChecked, "DurationOneval DurationOneval");

  return (
    <>
      <div className="ClientBranchCreateEDIT">
        <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
          <div className="col BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          {EditId == undefined || EditId == "" ? (
                            <span> Branch</span>
                          ) : (
                            <span> Branch </span>
                          )}
                        </div>
                      </div>
                      <div className="Modal-Body Modal-bodyUserCRUD">
                        <div className="col-12 InnerModelDesigns">
                          <div>Branch Deatils</div>
                        </div>
                        {EditId === undefined || EditId == "" ? (
                          <>
                            <div className="row">
                              <div className="col-6">
                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Branch Name
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="client_name"
                                      value={data.client_name}
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setClientNaaErr("");
                                      }}
                                    />
                                    <p className="Error"> {clientNameEr} </p>
                                  </div>

                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Scope
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects ScopeList "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                        zIndex: "9999",
                                      }}
                                      onChange={(e) => {
                                        handlethescopeValues(e);
                                        setScopeErr("");
                                      }}
                                      options={scopeOPtions}
                                      labelledBy="Select"
                                      isMulti
                                      value={ScopeValues}
                                      onInputChange={handleInputscope}
                                    />
                                    <p className="Error"> {scopeErr} </p>
                                  </div>

                                  {/* <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Description
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={data.description}
                                      name="description"
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setDescriptionError("");
                                      }}
                                    />
                                    <p className="Error"> {DescriptionError} </p>
                                  </div> */}
                                </div>
                                {/* <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Email
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={data.Email}
                                      name="Email"
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setEmailErr("");
                                        // if ( !validator.isEmail(data.Email)) {
                                        //   setEmailErr("*Enter valid mail id");
                                        // }
                                      }}
                                    />
                                    <p className="Error"> {EmailErr} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Phone Number
                                    </label>
                                    <input
                                      type="number"
                                      // onKeyDown={(evt) =>
                                      //   ["e", "E", "+", "-"].includes(evt.key) &&
                                      //   evt.preventDefault()
                                      // }
                                      step="1"
                                      onKeyDown={(evt) => {
                                        preventZoom(evt)

                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel

                                      ref={inputRef}

                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={data.ph}
                                      name="ph"
                                      // onChange={(e) => {
                                      //   HandleChanges(e);
                                      //   setPhoneError("");
                                      // }}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        setPhoneError("");
                                        // Check if value exceeds 10 digits or is invalid
                                        if (value.length <= 10 && (phoneRegex.test(value) || value === '')) {
                                          HandleChanges(e);
                                        }
                                      }}
                                    />
                                    <p className="Error"> {PhoneError} </p>
                                  </div>
                                </div> */}

                                <div className="col-12 ClientPartsForms">
                                  <div
                                    className="col-6 mt-3"
                                    style={{ marginBottom: "20px" }}
                                  >
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Address
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <textarea
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="Address"
                                      value={data.Address}
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setAddressErr("");
                                      }}
                                    />
                                    <p className="Error"> {AddressErr} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      State
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      // options={options}
                                      // onChange={handleChange}
                                      onSelect={(e) => setMuliselect(e)}
                                      onChange={(e) => {
                                        handleSelectChange(e);
                                        setStateError("");
                                      }}
                                      onInputChange={handleInputChange}
                                      options={nameList}
                                      labelledBy="Select"
                                    />
                                    <p className="Error">{stateerror}</p>
                                  </div>
                                </div>

                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-5">
                                    <label
                                      for="validationCustom01"
                                      class="form-label "
                                    >
                                      Region
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects  "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                        zIndex: "10",
                                      }}
                                      // options={options}
                                      // onChange={handleChange}
                                      ///onSelect={(e) => setMuliselect1(e)}
                                      onClick={(e) => {
                                        setStateClicked(true);
                                      }}
                                      disabled={true}
                                      onChange={(e) => {
                                        handelRegionSlect(e);
                                        setRegionError("");
                                      }}
                                      onInputChange={handleInputRegion}
                                      options={nameList2}
                                      value={multiselect1}
                                      labelledBy="Select"
                                    />
                                    <p className="Error">{RegionError}</p>
                                  </div>
                                  <div className="col-6 mt-5">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Zone
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects   "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                        zIndex: "8",
                                      }}
                                      // options={options}
                                      // onChange={handleChange}
                                      onSelect={(e) => setMuliselect3(e)}
                                      onChange={(e) => {
                                        handleZone(e);
                                        setZoneError("");
                                      }}
                                      options={nameList4}
                                      labelledBy="Select"
                                      disabled={true}
                                      onInputChange={handleInputZone}
                                      value={multiselect3}
                                    />
                                    <p className="Error">{ZoneError}</p>
                                  </div>
                                </div>

                                <div className="col-12 mt-2 ClientPartsForms">
                                  <div className="col-6 mt-4">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Reporting Persons
                                      {/* <span style={{ color: "red" }}>*</span> */}
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      onChange={(e) => {
                                        handleMagerList(e);
                                        setReportingErr("");
                                      }}
                                      options={mangerOPtions}
                                      labelledBy="Select"
                                      isMulti
                                      value={mnagerlistselected}
                                      onInputChange={handleInputuser}
                                    />
                                    <p className="Error">{REportingErr}</p>
                                  </div>
                                  {console.log(
                                    mangerOPtions,
                                    "dajkdkjasjkda",
                                    data,
                                  )}

                                  <div className="col-6 mt-4">
                                    <label class="form-label">
                                      Organization
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      onChange={(e) => {
                                        handlOrganizationList(e);
                                        setorganizationerr("");
                                      }}
                                      options={Organization_options}
                                      labelledBy="Select"
                                      value={Organization_Val}
                                      onInputChange={handleInputOrganization}
                                    />
                                    <p className="Error">{organizationerro}</p>
                                  </div>
                                </div>
                                {data?.organization_id ==
                                  "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                                    <div className="col-12 ClientPartsForms">
                                      <div className="col-6 mt-4">
                                        <label class="form-label">
                                          RM
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={{
                                            position: "relative",
                                            top: "60px",
                                          }}
                                          onChange={(e) => {
                                            handleRM_List(e);
                                            // setorganizationerr("");
                                          }}
                                          isMulti
                                          options={Organization_RM_options}
                                          labelledBy="Select"
                                          value={organization_RM_Val}
                                          onInputChange={
                                            handleInputOrganizationRm
                                          }
                                        />
                                        {/* <p className="Error">
                                        {organizationerro}
                                      </p> */}
                                      </div>
                                      <div className="col-6 mt-4">
                                        <label class="form-label">
                                          PM
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={{
                                            position: "relative",
                                            top: "60px",
                                          }}
                                          isMulti
                                          onChange={(e) => {
                                            handlePM_List(e);
                                            // setorganizationerr("");
                                          }}
                                          options={Organization_RM_options}
                                          labelledBy="Select"
                                          value={organization_PM_Val}
                                          onInputChange={
                                            handleInputOrganizationRm
                                          }
                                        />
                                        {/* <p className="Error">
                                        {organizationerro}
                                      </p> */}
                                      </div>
                                      <div className="col-6 mt-4">
                                        <label class="form-label">
                                          VH
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={{
                                            position: "relative",
                                            top: "60px",
                                          }}
                                          onChange={(e) => {
                                            handleVH_List(e);
                                            // setorganizationerr("");
                                          }}
                                          isMulti
                                          options={Organization_RM_options}
                                          labelledBy="Select"
                                          value={organization_VH_Val}
                                          onInputChange={
                                            handleInputOrganizationRm
                                          }
                                        />
                                        {/* <p className="Error">
                                        {organizationerro}
                                      </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Project Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="project_code"
                                          value={data?.project_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            // setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                    </div>
                                  )}
                                {data?.organization_id ==
                                  "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                                    <div className="col-12 mt-2 ClientPartsForms">
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Program Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="program_code"
                                          value={data?.program_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Client Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="client_code"
                                          value={data?.client_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Division Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="division_code"
                                          value={data?.division_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            // setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Division Name
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="division_name"
                                          value={data?.division_name}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            // setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                    </div>
                                  )}
                                {data?.organization_id ==
                                  "28e108e0-a644-4365-89df-317867f00f22" && (
                                    <div className="col-12 mt-2 ClientPartsForms">
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Product Code
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="product_code"
                                          value={data?.product_code}
                                          onChange={(e) => {
                                            HandleChanges(e);

                                          }}
                                        />
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Division Level
                                        </label>
                                        <Select
                                          className="Selects"
                                          placeholder="Select..."
                                          isMulti
                                          isClearable
                                          options={divisionLevelOptions}
                                          value={toDivisionLevelList(
                                            data?.division_level,
                                          ).map((level) => ({
                                            value: level,
                                            label: level,
                                          }))}
                                          onChange={(selected) => {
                                            setData({
                                              ...data,
                                              division_level: (selected || []).map(
                                                (option) => option.value,
                                              ),
                                            });
                                          }}
                                        />
                                      </div></div>)}
                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 Mapof">
                                    <label class="form-label">Latitude</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="name"
                                      readOnly={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      disabled={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      value={mapCenter.lat}
                                      onChange={(e) => {
                                        setMapCenter({
                                          ...mapCenter,
                                          lat: Number(e.target.value),
                                        });
                                      }}
                                    />
                                  </div>

                                  <div className="col-6 Mapof">
                                    <label class="form-label">Longitude</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="name"
                                      readOnly={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      value={mapCenter.lng}
                                      disabled={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      onChange={(e) => {
                                        setMapCenter({
                                          ...mapCenter,
                                          lng: Number(e.target.value),
                                        });
                                      }}
                                    />
                                  </div>

                                  <div className="col-6 Mapof">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      <div
                                        className="col-12 LeaveButtonVeirif"
                                        style={{
                                          marginTop: "-39px",
                                          marginLeft: "0px",
                                          paddingLeft: "0px",
                                        }}
                                      >
                                        <div className="InnerChoicesDATA">
                                          <label
                                            className="BranchButton"
                                            style={{
                                              margin: "0px 0px 6px 0px",
                                            }}
                                          >
                                            <input
                                              className="form-check-input custom-radioRegurlarization"
                                              type="checkbox"
                                              checked={Attendance_verified}
                                              onChange={
                                                handleRadioChangeAttendance
                                              }
                                            />
                                            <span>Attendance For Branch</span>
                                          </label>
                                        </div>
                                      </div>
                                      Attendance Feature Type
                                      {Attendance_verified == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      onChange={(e) => {
                                        handleFeatureTypeChange(e);
                                        setAttendancesErr("");
                                      }}
                                      options={FEATURE_TYPE}
                                      value={selectedFeatureType}
                                    />
                                    <p className="Error">{AttendanceErr}</p>
                                  </div>

                                  <div className="col-6 Mapof">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Attendance Capture Radius (meters)
                                      {data?.attendance_features != "" &&
                                        data?.attendance_features != null &&
                                        data.attendance_features != "0" &&
                                        data.attendance_features != "1" ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : (
                                        ""
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      className="form-control"
                                      required
                                      autoComplete="off"
                                      name="geo_location_radius"
                                      value={data.geo_location_radius || ""}
                                      onWheel={(e) => e.target.blur()}
                                      onKeyDown={(e) => {
                                        if (
                                          ["e", "E", "+", "-", "."].includes(
                                            e.key,
                                          )
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pasted =
                                          e.clipboardData.getData("text");
                                        if (!/^[0-9]+$/.test(pasted)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // ✅ allow empty & numbers while typing
                                        if (/^[0-9]*$/.test(value)) {
                                          setradiuse_err("");
                                          HandleChanges(e); // ALWAYS update state
                                        }
                                      }}
                                      onBlur={(e) => {
                                        const value = Number(e.target.value);

                                        // ✅ validate range AFTER typing
                                        if (
                                          value &&
                                          (value < 10 || value > 50000)
                                        ) {
                                          setradiuse_err(
                                            "*Attendance radius must be between 10 m and 50,000 m",
                                          );
                                        }
                                      }}
                                    />

                                    <p className="Error"> {radius_err} </p>
                                  </div>
                                </div>
                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      <div
                                        className="col-12 LeaveButtonVeirif"
                                        style={{
                                          marginTop: "-39px",
                                          marginLeft: "-16px",
                                        }}
                                      >
                                        <div className="InnerChoicesDATA">
                                          <label className="BranchButton">
                                            <input
                                              className="form-check-input custom-radioRegurlarization"
                                              type="checkbox"
                                              checked={leaveRadioChecked}
                                              onChange={handleRadioChange}
                                            />
                                            <span>Leave For Branch</span>
                                          </label>
                                        </div>
                                      </div>
                                      Personal Leave (Per Month)
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}{" "}
                                    </label>

                                    <input
                                      type="number"
                                      onKeyDown={(evt) => {
                                        preventZoom(evt);
                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                      ref={inputRef}
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="personal_leave"
                                      value={
                                        data.personal_leave != undefined
                                          ? data.personal_leave
                                          : data.personal_leave
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        // const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        const phoneRegex = /^[0-9]{1,10}$/;

                                        setPersonslErr("");
                                        // Check if value exceeds 10 digits or is invalid
                                        if (
                                          value.length <= 1 &&
                                          (phoneRegex.test(value) ||
                                            value === "")
                                        ) {
                                          HandleChanges(e);
                                        }
                                      }}
                                    />
                                    <p className="Error">
                                      {" "}
                                      {personalLevaeErr}{" "}
                                    </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Casual Leave (Per Month)
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}{" "}
                                    </label>
                                    <input
                                      type="number"
                                      onKeyDown={(evt) => {
                                        preventZoom(evt);
                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                      ref={inputRef}
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={
                                        data.casual_leave != undefined
                                          ? data.casual_leave
                                          : data.casual_leave
                                      }
                                      name="casual_leave"
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        // const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        const phoneRegex = /^[0-9]{1,10}$/;
                                        setCasualErr("");

                                        if (
                                          value.length <= 1 &&
                                          (phoneRegex.test(value) ||
                                            value === "")
                                        ) {
                                          HandleChanges(e);
                                        }
                                      }}
                                    />
                                    <p className="Error"> {casualErro} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Extra Leave (Per Month)
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}{" "}
                                    </label>
                                    <input
                                      type="number"
                                      onKeyDown={(evt) => {
                                        preventZoom(evt);
                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                      ref={inputRef}
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={
                                        data.extra_leave != undefined
                                          ? data.extra_leave
                                          : data.extra_leave
                                      }
                                      name="extra_leave"
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        // const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        const phoneRegex = /^[0-9]{1,10}$/;

                                        setLeaveExtracErr("");
                                        // Check if value exceeds 10 digits or is invalid
                                        if (
                                          value.length <= 1 &&
                                          (phoneRegex.test(value) ||
                                            value === "")
                                        ) {
                                          HandleChanges(e);
                                        }
                                      }}
                                    />
                                    <p className="Error"> {ExtraLebErr} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Leave Type
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}{" "}
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      options={LeaveOptionse}
                                      isMulti
                                      onChange={HandleTheleaveType}
                                      value={LeaveMultiValues}
                                      onInputChange={(e) => {
                                        setSearchDebounance({
                                          ...SearchDebounance,
                                          leavetype: e,
                                        });
                                      }}
                                      labelledBy="Select"
                                    />
                                    <p className="Error">{LeaveTypeErr}</p>
                                  </div>
                                </div>
                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3 ">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      <div
                                        className="col-12 LeaveButtonVeirif p-0"
                                        style={{
                                          width: "100%",
                                          // marginTop: "-39px",
                                          // marginLeft: "-16px",
                                        }}
                                      >
                                        <div
                                          className="InnerChoicesDATA"
                                          style={{
                                            width: "100%",
                                            // marginTop: "-39px",
                                            // marginLeft: "-16px",
                                          }}
                                        >
                                          <label className="BranchButton">
                                            <input
                                              className="form-check-input custom-radioRegurlarization"
                                              type="checkbox"
                                              checked={ticketingRadioChecked}
                                              onChange={
                                                handleRadioChangeticketing
                                              }
                                            />
                                            <span>Ticketing For Branch</span>
                                          </label>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="col-6 Map "
                                style={{ padding: "22px", height: "100%" }}
                              >
                                <Map
                                  mapCenter={mapCenter}
                                  setMapCenter={setMapCenter}
                                  ChangeLocation={LocationChanges}
                                  SearchedLocaitons={SearchedLoc}
                                />
                              </div>
                            </div>

                            <div className="col-12 InnerModelDesigns">
                              <div className="ContactPersonDetails">
                                <div>Contact Person Details</div>

                                {inputFields.map((inputField, index) => (
                                  <Fragment key={`${inputField}~${index}`}>
                                    {index == 0 ? (
                                      <button
                                        className="AddedFragments "
                                        // disabled={ticketingRadioChecked == false}
                                        onClick={(index) => {
                                          let Err = 0;
                                          inputFields.map((item) => {
                                            console.log(item, "182634e98ditem");
                                            //  if(state.NumberCounts.Editable != 1){
                                            if (
                                              item.first_name == "" ||
                                              item.first_name == null ||
                                              item.first_name == undefined
                                            ) {
                                              setcontactNameerr(
                                                "*Name is required",
                                              );
                                              Err = 1;
                                            }

                                            if (
                                              item.phone_number == "" ||
                                              item.phone_number == null ||
                                              item.phone_number == undefined
                                            ) {
                                              setContactPhErr(
                                                "*Phone number is required",
                                              );
                                              Err = 1;
                                            }
                                            if (
                                              item.phone_number != "" &&
                                              item.phone_number.length < 10
                                            ) {
                                              setContactPhErr(
                                                "*Phone number should not less than 10 digits",
                                              );
                                              Err = 1;
                                            }

                                            if (
                                              item.password == "" ||
                                              item.password == null ||
                                              item.password == undefined
                                            ) {
                                              setPasserr(
                                                "*Password is required",
                                              );
                                              Err = 1;
                                            }
                                            if (
                                              item.email != "" &&
                                              !validator.isEmail(item.email)
                                            ) {
                                              setcontactEmailerr(
                                                "*Enter valid mail id",
                                              );
                                              Err = 1;
                                            }
                                            if (item.email == "") {
                                              setcontactEmailerr(
                                                "*Email is required",
                                              );
                                              Err = 1;
                                            }
                                          });

                                          if (Err == 0) {
                                            handleAddFields(index);
                                          }
                                        }}
                                      >
                                        Add Contact Person
                                      </button>
                                    ) : null}
                                  </Fragment>
                                ))}
                              </div>
                            </div>

                            <div className="row">
                              {inputFields.map((inputField, index) => (
                                <Fragment key={`${inputField}~${index}`}>
                                  <div
                                    className="form-group col-sm-12"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <div
                                      className=" btn  StatusList"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",

                                        gap: "20px",
                                      }}
                                    >
                                      {index !== 0 ? (
                                        <button
                                          className="DeclineStatusPrev "
                                          disabled={
                                            index === 0
                                            // ||
                                            // ticketingRadioChecked == false
                                          }
                                          onClick={() => {
                                            handleRemoveFields(index);
                                          }}
                                        >
                                          <span>
                                            <img src={minus} />
                                          </span>
                                        </button>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label
                                      htmlFor="firstName"
                                      class="form-label"
                                    >
                                      Name
                                      {ticketingRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id="firstName"
                                      name="first_name"
                                      value={inputField.first_name}
                                      autoComplete="off"
                                      onChange={(event) => {
                                        Handlefragmentchanges(index, event);
                                        setcontactNameerr("");
                                      }}
                                    // disabled={ticketingRadioChecked == false}
                                    />
                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {inputField.first_name != "" &&
                                        inputField.first_name != null &&
                                        inputField.first_name != undefined
                                        ? ""
                                        : contactnameerr}
                                    </p>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label
                                      htmlFor="lastName"
                                      class="form-label"
                                    >
                                      Email
                                      {ticketingRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id="firstName"
                                      name="email"
                                      value={inputField.email}
                                      autoComplete="off"
                                      onChange={(event) => {
                                        Handlefragmentchanges(index, event);
                                        setcontactEmailerr("");
                                      }}
                                    // disabled={ticketingRadioChecked == false}
                                    />

                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {inputField.email != "" &&
                                        inputField.email != null &&
                                        inputField.email != undefined &&
                                        validator.isEmail(inputField.email)
                                        ? ""
                                        : contactemail}
                                    </p>
                                  </div>
                                  <div className="form-group col-sm-3">
                                    <label
                                      htmlFor="lastName"
                                      class="form-label"
                                    >
                                      {" "}
                                      Phone number
                                      {ticketingRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <input
                                      type="number" // Changed from "number" to "text" to better control input
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "-" ||
                                          e.key === "e" ||
                                          e.key === "E"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onFocus={(e) => {
                                        e.target.addEventListener(
                                          "wheel",
                                          preventScrollnumber,
                                          {
                                            passive: false,
                                          },
                                        );
                                      }}
                                      onBlur={(e) => {
                                        e.target.removeEventListener(
                                          "wheel",
                                          preventScrollnumber,
                                        );
                                      }}
                                      // step="1"
                                      // onKeyDown={(evt) => {
                                      //   preventZoom(evt)
                                      // }}
                                      // onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      // onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel

                                      // ref={inputRef}
                                      className="form-control"
                                      id="firstName"
                                      name="phone_number"
                                      value={inputField.phone_number}
                                      autoComplete="off"
                                      onChange={(event) => {
                                        const value = event.target.value;

                                        const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        if (
                                          value.length <= 10 &&
                                          (phoneRegex.test(value) ||
                                            value === "")
                                        ) {
                                          Handlefragmentchanges(index, event);
                                          setContactPhErr("");
                                        }
                                      }}
                                    // disabled={ticketingRadioChecked == false}
                                    />
                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {inputField.phone_number &&
                                        inputField.phone_number.length >= 10
                                        ? ""
                                        : ContactphoneErr}
                                    </p>
                                  </div>
                                  <div className="form-group  col-sm-3">
                                    <label
                                      htmlFor="lastName"
                                      class="form-label"
                                    >
                                      Password
                                      {ticketingRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <div class="Password-Filed">
                                      <input
                                        type="text"
                                        className={` form-control  ${viewpass ? "activate" : "notactivate"
                                          }`}
                                        id="outlined-adornment-password"
                                        name="password"
                                        value={inputField.password}
                                        autoComplete="off"
                                        onChange={(event) => {
                                          Handlefragmentchanges(index, event);
                                          setPasserr("");
                                        }}
                                      // disabled={ticketingRadioChecked == false}
                                      />

                                      <i className="icon Paassswords">
                                        {viewpass ? (
                                          <RemoveRedEyeIcon
                                            onClick={(e) =>
                                              setViewpass(!viewpass)
                                            }
                                          ></RemoveRedEyeIcon>
                                        ) : (
                                          <VisibilityOffIcon
                                            onClick={(e) =>
                                              setViewpass(!viewpass)
                                            }
                                          ></VisibilityOffIcon>
                                        )}
                                      </i>
                                    </div>
                                    <p
                                      className="Error"
                                      style={{ paddingLeft: "4px" }}
                                    >
                                      {inputField.password != "" &&
                                        inputField.password != null &&
                                        inputField.password != undefined
                                        ? ""
                                        : PasswErr}
                                    </p>
                                  </div>
                                </Fragment>
                              ))}
                            </div>

                            <div className="col-12 InnerModelDesigns">
                              <div>TAT Details</div>
                            </div>

                            <div className="row">
                              <div className="col-12 mb-4 mt-3">
                                <div
                                  className="MatrixListhide col-12"
                                  onClick={() => {
                                    setLevelOnePersonst(!LonePersonsst);
                                  }}
                                >
                                  <span>L1</span>
                                  <img src={dropdownimg} />
                                </div>
                                {LonePersonsst && (
                                  <>
                                    <div className="LevelListeds col-12">
                                      <div className="col-sm-6 ">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Person
                                          {ticketingRadioChecked == true && (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <Select
                                          className="Selects RegionNames"
                                          styles={customStyles}
                                          onChange={(e) => {
                                            handleLoneUsers(e);
                                            setLoneuserserr("");
                                          }}
                                          options={LOneUserOptions}
                                          labelledBy="Select"
                                          isMulti
                                          value={LOne_user}
                                          onInputChange={handleInputuser}
                                        // isDisabled={ticketingRadioChecked == false}
                                        />

                                        <p className="Error">{LOne_userErr}</p>
                                      </div>

                                      <div
                                        className="col-6"
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Type
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <Select
                                            className="Selects"
                                            styles={{
                                              position: "relative",
                                              top: "60px",
                                            }}
                                            options={DurationOpions}
                                            labelledBy="Select"
                                            onChange={(e) => {
                                              HandleTheDurations(
                                                e,
                                                "l1time_type",
                                              );
                                              setL1TimeTypeErr("");
                                            }}
                                            value={DurationOneval}
                                            style={{ zIndex: "99" }}
                                          // isDisabled={ticketingRadioChecked == false}
                                          />
                                          <p className="Error">
                                            {L1TimeTypeErr}
                                          </p>
                                        </div>
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            TAT
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <input
                                            type="number" // Changed from "number" to "text" to better control input
                                            step="1"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt);
                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                                            ref={inputRef}
                                            className="form-control"
                                            id="firstName"
                                            name="l1_user_TAT"
                                            value={data.l1_user_TAT}
                                            autoComplete="off"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const phoneRegex =
                                                /^[1-9][0-9]{0,9}$/;
                                              const minutesRegex =
                                                /^([1-9]|[1-5][0-9])$/;

                                              if (data.l1_time_type == "0") {
                                                if (
                                                  minutesRegex.test(value) ||
                                                  value === ""
                                                ) {
                                                  HandleChanges(e);
                                                  setL1UserTATErr("");
                                                }
                                              } else if (
                                                phoneRegex.test(value) ||
                                                value === ""
                                              ) {
                                                HandleChanges(e);
                                                setL1UserTATErr("");
                                              }
                                            }}
                                          // disabled={ticketingRadioChecked == false}
                                          />
                                          <p className="Error">
                                            {L1UserTATErr}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    {LOne_user.length > 0 && (
                                      <div className="col-12 addedpeople">
                                        <div
                                          style={{ marginTop: "20px" }}
                                          className="col-12"
                                        >
                                          <h5>Added People</h5>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "15px",
                                              border: "1px solid #ddd",
                                              padding: "14px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {LOne_user.map((person) => (
                                              <div
                                                key={person.value}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  backgroundColor: "#F266391A",
                                                  borderRadius: "5px",
                                                  padding: "10px 12px",
                                                  width: "272px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "#F26639",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "16px",
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  {getInitials(person.label)}
                                                </div>
                                                <div style={{ flex: "1" }}>
                                                  <div
                                                    style={{
                                                      color: "#F26639",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.label,
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      color: "#000",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.role,
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="Handleremoveclosed">
                                                  <button
                                                    disabled={
                                                      ticketingRadioChecked ==
                                                      false
                                                    }
                                                    onClick={() =>
                                                      handleRemove(person)
                                                    }
                                                  >
                                                    {" "}
                                                    <img src={closebtnimg} />
                                                  </button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>

                              <div className="col-12 mb-4 ">
                                <div
                                  className="MatrixListhide col-12"
                                  onClick={() => {
                                    setLevelTwoPersonst(!LTwoPersonsst);
                                  }}
                                >
                                  <span>L2</span>
                                  <img src={dropdownimg} />
                                </div>
                                {LTwoPersonsst && (
                                  <>
                                    <div className="LevelListeds col-12">
                                      <div className="col-6 ">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Person
                                          {ticketingRadioChecked == true && (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          )}{" "}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={customStyles}
                                          onChange={(e) => {
                                            handleLTwoUsers(e);
                                            setLTwoUserserr("");
                                          }}
                                          options={Ltwooptions}
                                          labelledBy="Select"
                                          isMulti
                                          value={Ltwo_users}
                                          onInputChange={handleInputuser}
                                          isDisabled={
                                            // data.l1_user != null && data.l1_user != undefined &&
                                            data.l1_user == null ||
                                            data.l1_user == undefined ||
                                            data.l1_user.length == 0
                                            // ||
                                            // ticketingRadioChecked == false
                                          }
                                        />
                                        <p className="Error">{Ltwo_usersErr}</p>
                                      </div>

                                      <div
                                        className="col-6"
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Type
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <Select
                                            className="Selects "
                                            styles={{
                                              position: "relative",
                                              top: "60px",
                                            }}
                                            options={DurationOpions}
                                            labelledBy="Select"
                                            onChange={(e) => {
                                              HandleTheDurations(
                                                e,
                                                "l2time_type",
                                              );
                                              setL2TimeTypeErr("");
                                            }}
                                            value={DurationTwoval}
                                            style={{ zIndex: "99" }}
                                          // isDisabled={ticketingRadioChecked == false}
                                          />
                                          <p className="Error">
                                            {L2TimeTypeErr}
                                          </p>
                                        </div>

                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            TAT
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <input
                                            type="number" // Changed from "number" to "text" to better control input
                                            step="1"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt);
                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                                            ref={inputRef}
                                            className="form-control"
                                            id="firstName"
                                            name="l2_user_TAT"
                                            value={data.l2_user_TAT}
                                            autoComplete="off"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const phoneRegex =
                                                /^[1-9][0-9]{0,9}$/;
                                              const minutesRegex =
                                                /^([1-9]|[1-5][0-9])$/;

                                              if (data.l2_time_type == "0") {
                                                if (
                                                  minutesRegex.test(value) ||
                                                  value === ""
                                                ) {
                                                  HandleChanges(e);
                                                  setL2UserTATErr("");
                                                }
                                              } else if (
                                                phoneRegex.test(value) ||
                                                value === ""
                                              ) {
                                                HandleChanges(e);
                                                setL2UserTATErr("");
                                              }
                                            }}
                                          // disabled={ticketingRadioChecked == false}
                                          />
                                          <p className="Error">
                                            {L2UserTATErr}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    {Ltwo_users.length > 0 && (
                                      <div className="col-12 addedpeople">
                                        <div
                                          style={{ marginTop: "20px" }}
                                          className="col-12"
                                        >
                                          <h5>Added People</h5>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "15px",
                                              border: "1px solid #ddd",
                                              padding: "14px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {Ltwo_users.map((person) => (
                                              <div
                                                key={person.value}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  backgroundColor: "#F266391A",
                                                  // border: "1px solid #FFDDD8",
                                                  borderRadius: "5px",
                                                  padding: "10px 12px",
                                                  // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                  width: "272px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "#F26639",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "16px",
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  {getInitials(person.label)}
                                                </div>
                                                <div style={{ flex: "1" }}>
                                                  <div
                                                    style={{
                                                      color: "#F26639",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.label,
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      color: "#000",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.role,
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="Handleremoveclosed">
                                                  <button
                                                    disabled={
                                                      ticketingRadioChecked ==
                                                      false
                                                    }
                                                    onClick={() =>
                                                      handleRemoveperson2(
                                                        person,
                                                      )
                                                    }
                                                  >
                                                    <img src={closebtnimg} />
                                                  </button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>

                              <div className="col-12 mb-4 ">
                                <div
                                  className="MatrixListhide"
                                  onClick={() => {
                                    setLevelThreePersonst(!LThreePersonsst);
                                  }}
                                >
                                  <span>L3</span>
                                  <img src={dropdownimg} />
                                </div>
                                {LThreePersonsst && (
                                  <>
                                    <div className="LevelListeds col-12">
                                      <div className="col-6 ">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Person
                                          {ticketingRadioChecked == true && (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          )}{" "}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={customStyles}
                                          onChange={(e) => {
                                            handleLThreeUsers(e);
                                            setLthreeUserserr("");
                                          }}
                                          options={LthreeOptions}
                                          labelledBy="Select"
                                          isMulti
                                          value={LthreeUsers}
                                          onInputChange={handleInputuser}
                                          isDisabled={
                                            // data.l1_user != null && data.l1_user != undefined &&
                                            data.l1_user == null ||
                                            data.l1_user == undefined ||
                                            data.l1_user.length == 0 ||
                                            data.l2_user == null ||
                                            data.l2_user == undefined ||
                                            data.l2_user.length == 0
                                            // ||
                                            // ticketingRadioChecked == false
                                          }
                                        />
                                        <p className="Error">
                                          {LthreeUsersErr}
                                        </p>
                                      </div>

                                      <div
                                        className="col-6"
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Type
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <Select
                                            className="Selects "
                                            styles={{
                                              position: "relative",
                                              top: "60px",
                                            }}
                                            options={DurationOpions}
                                            labelledBy="Select"
                                            onChange={(e) => {
                                              HandleTheDurations(
                                                e,
                                                "l3time_type",
                                              );
                                              setL3TimeTypeErr("");
                                            }}
                                            // isDisabled={ticketingRadioChecked == false}

                                            value={Durationthreeval}
                                          />
                                          <p className="Error">
                                            {L3TimeTypeErr}
                                          </p>
                                        </div>

                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            TAT
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <input
                                            type="number" // Changed from "number" to "text" to better control input
                                            step="1"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt);
                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                                            ref={inputRef}
                                            className="form-control"
                                            id="firstName"
                                            name="l3_user_TAT"
                                            value={data.l3_user_TAT}
                                            autoComplete="off"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const phoneRegex =
                                                /^[1-9][0-9]{0,9}$/;
                                              const minutesRegex =
                                                /^([1-9]|[1-5][0-9])$/;

                                              // if ((phoneRegex.test(value) || value === '')) {
                                              //   HandleChanges(e);
                                              //   setL3UserTATErr("")
                                              // }

                                              if (data.l3_time_type == "0") {
                                                if (
                                                  minutesRegex.test(value) ||
                                                  value === ""
                                                ) {
                                                  HandleChanges(e);
                                                  setL3UserTATErr("");
                                                }
                                              } else if (
                                                phoneRegex.test(value) ||
                                                value === ""
                                              ) {
                                                HandleChanges(e);
                                                setL3UserTATErr("");
                                              }
                                            }}
                                          // disabled={ticketingRadioChecked == false}
                                          />

                                          <p className="Error">
                                            {L3UserTATErr}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    {LthreeUsers.length > 0 && (
                                      <div className="col-12 addedpeople">
                                        <div
                                          style={{ marginTop: "20px" }}
                                          className="col-12"
                                        >
                                          <h5>Added People</h5>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "15px",
                                              border: "1px solid #ddd",
                                              padding: "14px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {LthreeUsers.map((person) => (
                                              <div
                                                key={person.value}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  backgroundColor: "#F266391A",
                                                  // border: "1px solid #FFDDD8",
                                                  borderRadius: "5px",
                                                  padding: "10px 12px",
                                                  // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                  width: "272px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "#F26639",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "16px",
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  {getInitials(person.label)}
                                                </div>
                                                <div style={{ flex: "1" }}>
                                                  <div
                                                    style={{
                                                      color: "#F26639",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.label,
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      color: "#000",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.role,
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="Handleremoveclosed">
                                                  <button
                                                    disabled={
                                                      ticketingRadioChecked ==
                                                      false
                                                    }
                                                    onClick={() =>
                                                      handleRemoveperson3(
                                                        person,
                                                      )
                                                    }
                                                  >
                                                    <img src={closebtnimg} />
                                                  </button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>

                            <div className="col-12 InnerModelDesigns">
                              <div>Criticality</div>
                            </div>
                            <div className="row">
                              {data.scope_ids.length > 0 &&
                                state.CategoryListed?.CategoryDatas.map(
                                  (item, listed) => {
                                    return (
                                      <>
                                        <div className="col-12 cardofCategorys cardofCategoryscreate">
                                          <div className="InnereaderOfCate">
                                            {item.name}
                                          </div>
                                        </div>

                                        <div className="col-12  SubcategoryBoxDesigns">
                                          <div className=" col-6 SubInnercategoryBoxDesigns">
                                            {CategoryFields.map(
                                              (category, index) => (
                                                <Fragment
                                                  key={`${category}~${index}`}
                                                >
                                                  {category?.subcategorydata
                                                    .issue_id == item.id ? (
                                                    <>
                                                      <div className=" InnerCategorySub">
                                                        <div className="innerlabelbox innerlabelboxnames ">
                                                          {
                                                            category
                                                              ?.subcategorydata
                                                              ?.name
                                                          }
                                                        </div>
                                                        <div className="Prioritystatus">
                                                          <div className="innerlabelbox">
                                                            <Select
                                                              value={
                                                                category
                                                                  ?.subcategorydata
                                                                  ?.Priority
                                                              }
                                                              options={
                                                                Priorityoptions
                                                              }
                                                              name="Priority"
                                                              isDisabled
                                                            />
                                                          </div>
                                                        </div>

                                                        <div className="Prioritystatus">
                                                          <div className="innerlabelbox">
                                                            <Select
                                                              name="active"
                                                              isDisabled
                                                              value={
                                                                category
                                                                  ?.subcategorydata
                                                                  ?.is_active
                                                              }
                                                              options={
                                                                optionsforfilter
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </Fragment>
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    );
                                  },
                                )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="row">
                              <div className="col-6">
                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Branch
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="client_name"
                                      value={data.client_name}
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setClientNaaErr("");
                                      }}
                                    />
                                    <p className="Error"> {clientNameEr} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Scope
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects ScopeList "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                        zIndex: "9999",
                                      }}
                                      onChange={(e) => {
                                        handlethescopeValues(e);
                                        setScopeErr("");
                                      }}
                                      options={scopeOPtions}
                                      labelledBy="Select"
                                      isMulti
                                      value={ScopeValues}
                                      onInputChange={handleInputscope}
                                    />
                                    <p className="Error"> {scopeErr} </p>
                                  </div>

                                  {/* <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Description<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={data.description}
                                      name="description"
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setDescriptionError("");
                                      }}
                                    />
                                    <p className="Error"> {DescriptionError} </p>
                                  </div> */}
                                </div>

                                {/* <div className="col-12 ClientPartsForms">

                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Email
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      name="Email"
                                      value={data.Email}
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setEmailErr("");
                                      }}
                                    />
                                    <p className="Error"> {EmailErr} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Phone Number
                                    </label>
                                    <input
                                      type="number"
                                      // onKeyDown={(evt) =>
                                      //   ["e", "E", "+", "-"].includes(evt.key) &&
                                      //   evt.preventDefault()
                                      // }
                                      step="1"
                                      onKeyDown={(evt) => {
                                        preventZoom(evt)

                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel

                                      ref={inputRef}


                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={data.ph}
                                      name="ph"

                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        setPhoneError("");
                                        // Check if value exceeds 10 digits or is invalid
                                        if (value.length <= 10 && (phoneRegex.test(value) || value === '')) {
                                          HandleChanges(e);
                                        }
                                      }}

                                    />
                                    <p className="Error"> {PhoneError} </p>
                                  </div>
                                </div> */}
                                <div className="col-12 ClientPartsForms">
                                  <div
                                    className="col-6 mt-3"
                                    style={{ marginBottom: "20px" }}
                                  >
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Address
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    {/* <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="Address"
                                  value={data.Address}
                                  onChange={(e) => {
                                    HandleChanges(e);
                                    setAddressErr("");
                                  }}
                                /> */}
                                    <textarea
                                      class="form-control"
                                      type="text"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="Address"
                                      value={data.Address}
                                      onChange={(e) => {
                                        HandleChanges(e);
                                        setAddressErr("");
                                      }}
                                    />
                                    <p className="Error"> {AddressErr} </p>
                                  </div>

                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      State
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      // options={options}
                                      // onChange={handleChange}
                                      onSelect={(e) => setStateMul(e)}
                                      onChange={(e) => {
                                        handleState(e);
                                        setStateError("");
                                      }}
                                      onInputChange={handleInputChange}
                                      options={nameList}
                                      value={SelectedStates}
                                      labelledBy="Select"
                                    />
                                    <p className="Error">{stateerror}</p>
                                  </div>
                                </div>

                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Region
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                        zIndex: "8888",
                                      }}
                                      // options={options}
                                      // onChange={handleChange}
                                      onSelect={(e) => setRegionMUl(e)}
                                      onChange={(e) => {
                                        handleRegionSelected(e);
                                        setRegionError("");
                                      }}
                                      options={nameList2}
                                      value={SelectRegion}
                                      onInputChange={handleInputRegion}
                                      labelledBy="Select"
                                    />
                                    <p className="Error">{RegionError}</p>
                                  </div>

                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Zone
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects  "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                        zIndex: "8888",
                                      }}
                                      // options={options}
                                      // onChange={handleChange}
                                      onSelect={(e) => setZoneMulEdi(e)}
                                      onChange={(e) => {
                                        handleZoneEdits(e);
                                        setZoneError("");
                                      }}
                                      options={nameList4}
                                      value={SelectedZone}
                                      labelledBy="Select"
                                      onInputChange={handleInputZone}
                                    />
                                    <p className="Error">{ZoneError}</p>
                                  </div>

                                  {/* <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      State<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects stateNames"
                                      styles={{ position: "relative", top: "60px" }}
                                      // options={options}
                                      // onChange={handleChange}
                                      onSelect={(e) => setStateMul(e)}
                                      onChange={(e) => {
                                        handleState(e);
                                        setStateError("");
                                      }}
                                      onInputChange={handleInputChange}
                                      options={nameList}
                                      value={SelectedStates}
                                      labelledBy="Select"
                                    />
                                    <p className="Error">{stateerror}</p>
                                  </div> */}
                                </div>

                                <div className="col-12 mt-2 ClientPartsForms">
                                  <div className="col-6 mt-4">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Reporting Persons
                                      {/* <span style={{ color: "red" }}>*</span> */}
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      onChange={(e) => {
                                        handleMagerList(e);
                                        setReportingErr("");
                                      }}
                                      options={mangerOPtions}
                                      labelledBy="Select"
                                      isMulti
                                      value={mnagerlistselected}
                                      onInputChange={handleInputuser}
                                    />
                                    <p className="Error">{REportingErr}</p>
                                  </div>

                                  <div className="col-6 mt-4">

                                    <label class="form-label">
                                      Organization
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      onChange={(e) => {
                                        handlOrganizationList(e);
                                        setorganizationerr("");
                                      }}
                                      options={Organization_options}
                                      labelledBy="Select"
                                      value={Organization_Val}
                                      onInputChange={handleInputOrganization}
                                    />
                                    <p className="Error">
                                      {organizationerro}
                                    </p>
                                  </div>
                                </div>
                                {console.log(data, "asdkadladadklad")}
                                {data?.organization_id ==
                                  "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                                    <div className="col-12 ClientPartsForms">
                                      <div className="col-6 mt-4">
                                        <label class="form-label">
                                          RM
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={{
                                            position: "relative",
                                            top: "60px",
                                          }}
                                          onChange={(e) => {
                                            handleRM_List(e);
                                            // setorganizationerr("");
                                          }}
                                          isMulti
                                          options={Organization_RM_options}
                                          labelledBy="Select"
                                          value={organization_RM_Val}
                                          onInputChange={
                                            handleInputOrganizationRm
                                          }
                                        />
                                        {/* <p className="Error">
                                        {organizationerro}
                                      </p> */}
                                      </div>
                                      <div className="col-6 mt-4">
                                        <label class="form-label">
                                          PM
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={{
                                            position: "relative",
                                            top: "60px",
                                          }}
                                          isMulti
                                          onChange={(e) => {
                                            handlePM_List(e);
                                            // setorganizationerr("");
                                          }}
                                          options={Organization_RM_options}
                                          labelledBy="Select"
                                          value={organization_PM_Val}
                                          onInputChange={
                                            handleInputOrganizationRm
                                          }
                                        />
                                        {/* <p className="Error">
                                        {organizationerro}
                                      </p> */}
                                      </div>
                                      <div className="col-6 mt-4">
                                        <label class="form-label">
                                          VH
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={{
                                            position: "relative",
                                            top: "60px",
                                          }}
                                          onChange={(e) => {
                                            handleVH_List(e);
                                            // setorganizationerr("");
                                          }}
                                          isMulti
                                          options={Organization_RM_options}
                                          labelledBy="Select"
                                          value={organization_VH_Val}
                                          onInputChange={
                                            handleInputOrganizationRm
                                          }
                                        />
                                        {/* <p className="Error">
                                        {organizationerro}
                                      </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Project Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="project_code"
                                          value={data?.project_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            // setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                    </div>
                                  )}

                                {data?.organization_id ==
                                  "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                                    <div className="col-12 mt-2 ClientPartsForms">
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Program Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="program_code"
                                          value={data?.program_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Client Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="client_code"
                                          value={data?.client_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Division Code
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="division_code"
                                          value={data?.division_code}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            // setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Division Name
                                          {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="division_name"
                                          value={data?.division_name}
                                          onChange={(e) => {
                                            HandleChanges(e);
                                            // setClientNaaErr("");
                                          }}
                                        />
                                        {/* <p className="Error"> {clientNameEr} </p> */}
                                      </div>
                                    </div>
                                  )}
                                {data?.organization_id ==
                                  "28e108e0-a644-4365-89df-317867f00f22" && (
                                    <div className="col-12 mt-2 ClientPartsForms">
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Product Code
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          id="validationCustom01"
                                          autocomplete="off"
                                          name="product_code"
                                          value={data?.product_code}
                                          onChange={(e) => {
                                            HandleChanges(e);

                                          }}
                                        />
                                      </div>
                                      <div className="col-6 mt-3">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Division Level
                                        </label>
                                        <Select
                                          className="Selects"
                                          placeholder="Select..."
                                          isMulti
                                          isClearable
                                          options={divisionLevelOptions}
                                          value={toDivisionLevelList(
                                            data?.division_level,
                                          ).map((level) => ({
                                            value: level,
                                            label: level,
                                          }))}
                                          onChange={(selected) => {
                                            setData({
                                              ...data,
                                              division_level: (selected || []).map(
                                                (option) => option.value,
                                              ),
                                            });
                                          }}
                                        />
                                      </div></div>)}

                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 Mapof">
                                    <label class="form-label">Latitude</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="name"
                                      readOnly={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      disabled={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      value={mapCenter.lat}
                                      onChange={(e) => {
                                        setMapCenter({
                                          ...mapCenter,
                                          lat: Number(e.target.value),
                                        });
                                      }}
                                    />
                                  </div>
                                  <div className="col-6 Mapof">
                                    <label class="form-label">Longitude</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="name"
                                      readOnly={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      value={mapCenter.lng}
                                      disabled={
                                        state.ClientBranchIDs.SUBROLE == 3
                                          ? false
                                          : true
                                      }
                                      onChange={(e) => {
                                        setMapCenter({
                                          ...mapCenter,
                                          lng: Number(e.target.value),
                                        });
                                      }}
                                    />
                                  </div>
                                  {/* <div className="col-6 Mapof ">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      <div
                                        className="col-12 LeaveButtonVeirif p-0"
                                        style={{
                                          width: "100%",
                                        }}
                                      >
                                        <div
                                          className="InnerChoicesDATA"
                                          style={{
                                            width: "100%",
                                          }}
                                        >
                                          <label className="BranchButton">
                                            <input
                                              className="form-check-input custom-radioRegurlarization"
                                              type="checkbox"
                                              checked={Attendance_verified}
                                              onChange={
                                                handleRadioChangeAttendance
                                              }
                                            />
                                            <span>Attendance For Branch</span>
                                          </label>
                                        </div>
                                      </div>
                                    </label>
                                  </div> */}
                                  <div className="col-6 Mapof">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      <div
                                        className="col-12 LeaveButtonVeirif"
                                        style={{
                                          marginTop: "-39px",
                                          marginLeft: "0px",
                                          paddingLeft: "0px",
                                        }}
                                      >
                                        <div className="InnerChoicesDATA">
                                          <label
                                            className="BranchButton"
                                            style={{
                                              margin: "0px 0px 6px 0px",
                                            }}
                                          >
                                            <input
                                              className="form-check-input custom-radioRegurlarization"
                                              type="checkbox"
                                              checked={Attendance_verified}
                                              onChange={
                                                handleRadioChangeAttendance
                                              }
                                            />
                                            <span>Attendance For Branch</span>
                                          </label>
                                        </div>
                                      </div>
                                      Attendance Feature Type
                                      {Attendance_verified == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      onChange={(e) => {
                                        handleFeatureTypeChange(e);
                                        setAttendancesErr("");
                                      }}
                                      options={FEATURE_TYPE}
                                      value={selectedFeatureType}
                                    />
                                    <p className="Error">{AttendanceErr}</p>
                                  </div>
                                  <div className="col-6 Mapof">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Attendance Capture Radius (meters){" "}
                                      {data?.attendance_features != "" &&
                                        data?.attendance_features != null &&
                                        data.attendance_features != "0" &&
                                        data.attendance_features != "1" ? (
                                        <span style={{ color: "red" }}>*</span>
                                      ) : (
                                        ""
                                      )}
                                    </label>
                                    <input
                                      type="text"
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      className="form-control"
                                      required
                                      autoComplete="off"
                                      name="geo_location_radius"
                                      value={data.geo_location_radius || ""}
                                      onWheel={(e) => e.target.blur()}
                                      onKeyDown={(e) => {
                                        if (
                                          ["e", "E", "+", "-", "."].includes(
                                            e.key,
                                          )
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pasted =
                                          e.clipboardData.getData("text");
                                        if (!/^[0-9]+$/.test(pasted)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // ✅ allow empty & numbers while typing
                                        if (/^[0-9]*$/.test(value)) {
                                          setradiuse_err("");
                                          HandleChanges(e); // ALWAYS update state
                                        }
                                      }}
                                      onBlur={(e) => {
                                        const value = Number(e.target.value);

                                        // ✅ validate range AFTER typing
                                        if (
                                          value &&
                                          (value < 10 || value > 50000)
                                        ) {
                                          setradiuse_err(
                                            "*Attendance radius must be between 10 m and 50,000 m",
                                          );
                                        }
                                      }}
                                    />

                                    <p className="Error"> {radius_err} </p>
                                  </div>
                                </div>
                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      <div
                                        className="col-12 LeaveButtonVeirif"
                                        style={{
                                          marginTop: "-39px",
                                          marginLeft: "-16px",
                                        }}
                                      >
                                        <div className="InnerChoicesDATA">
                                          <label className="BranchButton">
                                            <input
                                              className="form-check-input custom-radioRegurlarization"
                                              type="checkbox"
                                              checked={leaveRadioChecked}
                                              onChange={handleRadioChange}
                                            />
                                            <span>Leave For Branch</span>
                                          </label>
                                        </div>
                                      </div>
                                      {console.log(data, "dajsjdkjdakjjdks")}
                                      Personal Leave (Per Month)
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <input
                                      type="number"
                                      onKeyDown={(evt) => {
                                        preventZoom(evt);
                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                      ref={inputRef}
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      // maxLength={9}
                                      name="personal_leave"
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        // const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        const phoneRegex = /^[0-9]{1,10}$/;

                                        setPersonslErr("");
                                        // Check if value exceeds 10 digits or is invalid
                                        if (
                                          value.length <= 1 &&
                                          (phoneRegex.test(value) ||
                                            value === "")
                                        ) {
                                          HandleChanges(e);
                                        }
                                      }}
                                      value={data?.personal_leave}
                                    />
                                    <p className="Error">
                                      {" "}
                                      {personalLevaeErr}{" "}
                                    </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Casual Leave (Per Month)
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <input
                                      type="number"
                                      class="form-control"
                                      required
                                      onKeyDown={(evt) => {
                                        preventZoom(evt);
                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                      ref={inputRef}
                                      autocomplete="off"
                                      // maxLength={9}
                                      value={data.casual_leave}
                                      name="casual_leave"
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        // const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        const phoneRegex = /^[0-9]{1,10}$/;

                                        setCasualErr("");
                                        // Check if value exceeds 10 digits or is invalid
                                        if (
                                          value.length <= 1 &&
                                          (phoneRegex.test(value) ||
                                            value === "")
                                        ) {
                                          HandleChanges(e);
                                        }
                                      }}
                                    />
                                    <p className="Error"> {casualErro} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Extra Leave (Per Month)
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}{" "}
                                    </label>
                                    <input
                                      type="number"
                                      onKeyDown={(evt) => {
                                        preventZoom(evt);
                                      }}
                                      onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                      onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel
                                      ref={inputRef}
                                      class="form-control"
                                      required
                                      autocomplete="off"
                                      value={
                                        data.extra_leave != undefined
                                          ? data.extra_leave
                                          : data.extra_leave
                                      }
                                      name="extra_leave"
                                      // onChange={(e) => {
                                      //   // if (e.target.value.length <= 2) {
                                      //   //   HandleChanges(e);
                                      //   //   setCasualErr("");
                                      //   // }

                                      //   const value = e.target.value
                                      //   .replace(/[^\w\s]/gi, "")
                                      //   .slice(0, 20);
                                      // HandleChanges(e);

                                      // if (value > 9) {
                                      //   setLeaveExtracErr(
                                      //     "Extra Leave should not exceed 9 Number."
                                      //   );
                                      //   setErrInde(1);
                                      // } else {
                                      //   setLeaveExtracErr("");
                                      //   setErrInde(0);
                                      // }

                                      // }}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Regular expression to validate phone number
                                        // const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                        const phoneRegex = /^[0-9]{1,10}$/;

                                        setLeaveExtracErr("");
                                        // Check if value exceeds 10 digits or is invalid
                                        if (
                                          value.length <= 1 &&
                                          (phoneRegex.test(value) ||
                                            value === "")
                                        ) {
                                          HandleChanges(e);
                                        }
                                      }}
                                    />
                                    <p className="Error"> {ExtraLebErr} </p>
                                  </div>
                                  <div className="col-6 mt-3">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      Leave Type
                                      {leaveRadioChecked == true && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}{" "}
                                    </label>
                                    <Select
                                      className="Selects "
                                      styles={{
                                        position: "relative",
                                        top: "60px",
                                      }}
                                      options={LeaveOptionse}
                                      isMulti
                                      onChange={HandleTheleaveType}
                                      value={LeaveMultiValues}
                                      onInputChange={(e) => {
                                        setSearchDebounance({
                                          ...SearchDebounance,
                                          leavetype: e,
                                        });
                                      }}
                                      labelledBy="Select"
                                    />
                                    <p className="Error">{LeaveTypeErr}</p>
                                  </div>
                                </div>
                                <div className="col-12 ClientPartsForms">
                                  <div className="col-6 mt-3 ">
                                    <label
                                      for="validationCustom01"
                                      class="form-label"
                                    >
                                      <div
                                        className="col-12 LeaveButtonVeirif p-0"
                                        style={{
                                          width: "100%",
                                          // marginTop: "-39px",
                                          // marginLeft: "-16px",
                                        }}
                                      >
                                        <div
                                          className="InnerChoicesDATA"
                                          style={{
                                            width: "100%",
                                            // marginTop: "-39px",
                                            // marginLeft: "-16px",
                                          }}
                                        >
                                          <label className="BranchButton">
                                            <input
                                              className="form-check-input custom-radioRegurlarization"
                                              type="checkbox"
                                              checked={ticketingRadioChecked}
                                              onChange={
                                                handleRadioChangeticketing
                                              }
                                            />
                                            <span>Ticketing For Branch</span>
                                          </label>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="col-6 Map"
                                style={{ padding: "22px", height: "100%" }}
                              >
                                <Map
                                  mapCenter={mapCenter}
                                  setMapCenter={setMapCenter}
                                  ChangeLocation={LocationChanges}
                                  SearchedLocaitons={SearchedLoc}
                                />
                              </div>
                            </div>

                            <div className="col-12 InnerModelDesigns">
                              <div className="ContactPersonDetails">
                                <div>Contact Person Details</div>

                                {inputFields.map((inputField, index) => (
                                  <Fragment key={`${inputField}~${index}`}>
                                    {index == 0 ? (
                                      <button
                                        className="AddedFragments "
                                        // disabled={ticketingRadioChecked == false}
                                        onClick={(index) => {
                                          let Err = 0;
                                          inputFields.map((item) => {
                                            console.log(item, "182634e98ditem");
                                            //  if(state.NumberCounts.Editable != 1){
                                            if (
                                              item.first_name == "" ||
                                              item.first_name == null ||
                                              item.first_name == undefined
                                            ) {
                                              setcontactNameerr(
                                                "*Name is required",
                                              );
                                              Err = 1;
                                            }

                                            if (
                                              item.phone_number == "" ||
                                              item.phone_number == null ||
                                              item.phone_number == undefined
                                            ) {
                                              setContactPhErr(
                                                "*Phone number is required",
                                              );
                                              Err = 1;
                                            }
                                            if (
                                              item.phone_number != "" &&
                                              item.phone_number.length < 10
                                            ) {
                                              setContactPhErr(
                                                "*Phone number should not less than 10 digits",
                                              );
                                              Err = 1;
                                            }

                                            // if (item.password == "" || item.password == null || item.password == undefined) {
                                            //   setPasserr("*Password is required");
                                            //   Err = 1;

                                            // }
                                            if (
                                              item.email != "" &&
                                              !validator.isEmail(item.email)
                                            ) {
                                              setcontactEmailerr(
                                                "*Enter valid mail id",
                                              );
                                              Err = 1;
                                            }
                                            if (item.email == "") {
                                              setcontactEmailerr(
                                                "*Email is required",
                                              );
                                              Err = 1;
                                            }
                                          });

                                          if (Err == 0) {
                                            handleAddFields(index);
                                          }
                                        }}
                                      >
                                        Add Contact Person
                                      </button>
                                    ) : null}
                                  </Fragment>
                                ))}
                              </div>
                            </div>

                            <div className="row">
                              {inputFields.map((inputField, index) => (
                                <Fragment key={`${inputField}~${index}`}>
                                  <div
                                    className="form-group col-sm-12"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <div
                                      className=" btn  StatusList"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",

                                        gap: "20px",
                                      }}
                                    >
                                      {index !== 0 ? (
                                        <button
                                          className="DeclineStatusPrev "
                                          disabled={index === 0}
                                          onClick={() => {
                                            handleRemoveFields(index);
                                          }}
                                        >
                                          <span>
                                            <img src={minus} />
                                          </span>
                                        </button>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="ContactEdit">
                                    <div className="form-group col-sm-3">
                                      <label
                                        htmlFor="firstName"
                                        class="form-label"
                                      >
                                        Name
                                        {ticketingRadioChecked == true && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        id="firstName"
                                        name="first_name"
                                        value={inputField.first_name}
                                        autoComplete="off"
                                        onChange={(event) => {
                                          Handlefragmentchanges(index, event);
                                          setcontactNameerr("");
                                        }}
                                      // disabled={ticketingRadioChecked == false}
                                      />
                                      <p
                                        className="Error"
                                        style={{ paddingLeft: "4px" }}
                                      >
                                        {inputField.first_name != "" &&
                                          inputField.first_name != null &&
                                          inputField.first_name != undefined
                                          ? ""
                                          : contactnameerr}
                                      </p>
                                    </div>
                                    <div className="form-group col-sm-3">
                                      <label
                                        htmlFor="lastName"
                                        class="form-label"
                                      >
                                        Email
                                        {ticketingRadioChecked == true && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        id="firstName"
                                        name="email"
                                        value={inputField.email}
                                        autoComplete="off"
                                        onChange={(event) => {
                                          Handlefragmentchanges(index, event);
                                          setcontactEmailerr("");
                                        }}
                                      // disabled={ticketingRadioChecked == false}
                                      />

                                      <p
                                        className="Error"
                                        style={{ paddingLeft: "4px" }}
                                      >
                                        {inputField.email != "" &&
                                          inputField.email != null &&
                                          inputField.email != undefined &&
                                          validator.isEmail(inputField.email)
                                          ? ""
                                          : contactemail}
                                      </p>
                                    </div>
                                    <div className="form-group col-sm-3">
                                      <label
                                        htmlFor="lastName"
                                        class="form-label"
                                      >
                                        {" "}
                                        Phone number
                                        {ticketingRadioChecked == true && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </label>
                                      <input
                                        type="number" // Changed from "number" to "text" to better control input
                                        // step="1"
                                        // onKeyDown={(evt) => {
                                        //   preventZoom(evt)
                                        // }}
                                        // onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                        // onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel

                                        // ref={inputRef}
                                        className="form-control"
                                        id="firstName"
                                        name="phone_number"
                                        value={inputField.phone_number}
                                        autoComplete="off"
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "-" ||
                                            e.key === "e" ||
                                            e.key === "E"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onFocus={(e) => {
                                          e.target.addEventListener(
                                            "wheel",
                                            preventScrollnumber,
                                            {
                                              passive: false,
                                            },
                                          );
                                        }}
                                        onBlur={(e) => {
                                          e.target.removeEventListener(
                                            "wheel",
                                            preventScrollnumber,
                                          );
                                        }}
                                        onChange={(event) => {
                                          const value = event.target.value;

                                          const phoneRegex =
                                            /^[1-9][0-9]{0,9}$/;
                                          if (
                                            value.length <= 10 &&
                                            (phoneRegex.test(value) ||
                                              value === "")
                                          ) {
                                            Handlefragmentchanges(index, event);
                                            setContactPhErr("");
                                          }
                                        }}
                                      // disabled={ticketingRadioChecked == false}
                                      />
                                      <p
                                        className="Error"
                                        style={{ paddingLeft: "4px" }}
                                      >
                                        {inputField.phone_number &&
                                          inputField.phone_number.length >= 10
                                          ? ""
                                          : ContactphoneErr}
                                      </p>
                                    </div>
                                    <div className="form-group  col-sm-3">
                                      <label
                                        htmlFor="lastName"
                                        class="form-label"
                                      >
                                        Password
                                        {ticketingRadioChecked == true && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </label>
                                      <div class="Password-Filed">
                                        <input
                                          type="text"
                                          className={` form-control  ${viewpass
                                            ? "activate"
                                            : "notactivate"
                                            }`}
                                          id="outlined-adornment-password"
                                          name="password"
                                          value={inputField.password}
                                          autoComplete="off"
                                          onChange={(event) => {
                                            Handlefragmentchanges(index, event);
                                            setPasserr("");
                                          }}
                                        // disabled={ticketingRadioChecked == false}
                                        />

                                        <i className="icon Paassswords">
                                          {viewpass ? (
                                            <RemoveRedEyeIcon
                                              onClick={(e) =>
                                                setViewpass(!viewpass)
                                              }
                                            ></RemoveRedEyeIcon>
                                          ) : (
                                            <VisibilityOffIcon
                                              onClick={(e) =>
                                                setViewpass(!viewpass)
                                              }
                                            ></VisibilityOffIcon>
                                          )}
                                        </i>
                                      </div>
                                      <p
                                        className="Error"
                                        style={{ paddingLeft: "4px" }}
                                      >
                                        {!inputField.id
                                          ? inputFields[index].password != "" &&
                                            inputFields[index].password !=
                                            null &&
                                            inputFields[index].password !=
                                            undefined
                                            ? ""
                                            : PasswErr
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="ContactEditSubmit">
                                    {inputField.id ? (
                                      <button
                                        // disabled={ticketingRadioChecked == false}

                                        onClick={() => {
                                          console.log(inputField, "inputField");

                                          Handlethecontactedit(
                                            inputField,
                                            inputField.id,
                                          );
                                        }}
                                      >
                                        Save
                                      </button>
                                    ) : (
                                      <button
                                        // disabled={ticketingRadioChecked == false}

                                        onClick={() => {
                                          // console.log(inputField, "inputField");

                                          HandlethecontactPost(
                                            inputField,
                                            inputField.id,
                                            index,
                                          );
                                        }}
                                      >
                                        Save
                                      </button>
                                    )}
                                  </div>
                                </Fragment>
                              ))}
                            </div>

                            <div className="col-12 InnerModelDesigns">
                              <div>TAT Details</div>
                            </div>

                            <div className="row">
                              <div className="col-12 mb-4 mt-3">
                                <div
                                  className="MatrixListhide col-12"
                                  onClick={() => {
                                    setLevelOnePersonst(!LonePersonsst);
                                  }}
                                >
                                  <span>L1</span>
                                  <img src={dropdownimg} />
                                </div>
                                {LonePersonsst && (
                                  <>
                                    <div className="LevelListeds col-12">
                                      <div className="col-sm-6 ">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Person
                                          {ticketingRadioChecked == true && (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <Select
                                          className="Selects RegionNames"
                                          styles={customStyles}
                                          onChange={(e) => {
                                            handleLoneUsers(e);
                                            setLoneuserserr("");
                                          }}
                                          options={LOneUserOptions}
                                          labelledBy="Select"
                                          isMulti
                                          value={LOne_user}
                                          onInputChange={handleInputuser}
                                        // isDisabled={ticketingRadioChecked == false}
                                        />

                                        <p className="Error">{LOne_userErr}</p>
                                      </div>

                                      <div
                                        className="col-6"
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Type
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <Select
                                            className="Selects"
                                            styles={{
                                              position: "relative",
                                              top: "60px",
                                            }}
                                            options={DurationOpions}
                                            labelledBy="Select"
                                            onChange={(e) => {
                                              HandleTheDurations(
                                                e,
                                                "l1time_type",
                                              );
                                              setL1TimeTypeErr("");
                                            }}
                                            value={DurationOneval}
                                            style={{ zIndex: "99" }}
                                          // isDisabled={ticketingRadioChecked == false}
                                          />
                                          <p className="Error">
                                            {L1TimeTypeErr}
                                          </p>
                                        </div>
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            TAT
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <input
                                            type="number" // Changed from "number" to "text" to better control input
                                            step="1"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt);
                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                                            ref={inputRef}
                                            className="form-control"
                                            id="firstName"
                                            name="l1_user_TAT"
                                            value={data.l1_user_TAT}
                                            // disabled={ticketingRadioChecked == false}

                                            autoComplete="off"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const phoneRegex =
                                                /^[1-9][0-9]{0,9}$/;
                                              const minutesRegex =
                                                /^([1-9]|[1-5][0-9])$/;

                                              if (data.l1_time_type == "0") {
                                                if (
                                                  minutesRegex.test(value) ||
                                                  value === ""
                                                ) {
                                                  HandleChanges(e);
                                                  setL1UserTATErr("");
                                                }
                                              } else if (
                                                phoneRegex.test(value) ||
                                                value === ""
                                              ) {
                                                HandleChanges(e);
                                                setL1UserTATErr("");
                                              }
                                            }}
                                          />
                                          <p className="Error">
                                            {L1UserTATErr}
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    {LOne_user.length > 0 && (
                                      <div className="col-12 addedpeople">
                                        <div
                                          style={{ marginTop: "20px" }}
                                          className="col-12"
                                        >
                                          <h5>Added People</h5>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "15px",
                                              border: "1px solid #ddd",
                                              padding: "14px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {LOne_user.map((person) => (
                                              <div
                                                key={person.value}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  backgroundColor: "#F266391A",
                                                  borderRadius: "5px",
                                                  padding: "10px 12px",
                                                  width: "272px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "#F26639",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "16px",
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  {getInitials(person.label)}
                                                </div>
                                                <div style={{ flex: "1" }}>
                                                  <div
                                                    style={{
                                                      color: "#F26639",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.label,
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      color: "#000",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.role,
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="Handleremoveclosed">
                                                  <button
                                                    disabled={
                                                      ticketingRadioChecked ==
                                                      false
                                                    }
                                                    onClick={() =>
                                                      handleRemove(person)
                                                    }
                                                  >
                                                    {" "}
                                                    <img src={closebtnimg} />
                                                  </button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>

                              <div className="col-12 mb-4 ">
                                <div
                                  className="MatrixListhide col-12"
                                  onClick={() => {
                                    setLevelTwoPersonst(!LTwoPersonsst);
                                  }}
                                >
                                  <span>L2</span>
                                  <img src={dropdownimg} />
                                </div>
                                {LTwoPersonsst && (
                                  <>
                                    <div className="LevelListeds col-12">
                                      <div className="col-6 ">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Person
                                          {ticketingRadioChecked == true && (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={customStyles}
                                          onChange={(e) => {
                                            handleLTwoUsers(e);
                                            setLTwoUserserr("");
                                          }}
                                          options={Ltwooptions}
                                          labelledBy="Select"
                                          isMulti
                                          value={Ltwo_users}
                                          onInputChange={handleInputuser}
                                          isDisabled={
                                            // data.l1_user != null && data.l1_user != undefined &&
                                            data.l1_user == null ||
                                            data.l1_user == undefined ||
                                            data.l1_user.length == 0
                                            // ||
                                            // ticketingRadioChecked == false
                                          }
                                        />
                                        <p className="Error">{Ltwo_usersErr}</p>
                                      </div>

                                      <div
                                        className="col-6"
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Type
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <Select
                                            className="Selects "
                                            styles={{
                                              position: "relative",
                                              top: "60px",
                                            }}
                                            options={DurationOpions}
                                            labelledBy="Select"
                                            onChange={(e) => {
                                              HandleTheDurations(
                                                e,
                                                "l2time_type",
                                              );
                                              setL2TimeTypeErr("");
                                            }}
                                            value={DurationTwoval}
                                            style={{ zIndex: "99" }}
                                          // isDisabled={ticketingRadioChecked == false}
                                          />
                                          <p className="Error">
                                            {L2TimeTypeErr}
                                          </p>
                                        </div>

                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            TAT
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <input
                                            type="number" // Changed from "number" to "text" to better control input
                                            step="1"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt);
                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                                            ref={inputRef}
                                            className="form-control"
                                            id="firstName"
                                            name="l2_user_TAT"
                                            value={data.l2_user_TAT}
                                            autoComplete="off"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const phoneRegex =
                                                /^[1-9][0-9]{0,9}$/;
                                              const minutesRegex =
                                                /^([1-9]|[1-5][0-9])$/;

                                              if (data.l2_time_type == "0") {
                                                if (
                                                  minutesRegex.test(value) ||
                                                  value === ""
                                                ) {
                                                  HandleChanges(e);
                                                  setL2UserTATErr("");
                                                }
                                              } else if (
                                                phoneRegex.test(value) ||
                                                value === ""
                                              ) {
                                                HandleChanges(e);
                                                setL2UserTATErr("");
                                              }
                                            }}
                                          // disabled={ticketingRadioChecked == false}
                                          />
                                          <p className="Error">
                                            {L2UserTATErr}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    {Ltwo_users.length > 0 && (
                                      <div className="col-12 addedpeople">
                                        <div
                                          style={{ marginTop: "20px" }}
                                          className="col-12"
                                        >
                                          <h5>Added People</h5>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "15px",
                                              border: "1px solid #ddd",
                                              padding: "14px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {Ltwo_users.map((person) => (
                                              <div
                                                key={person.value}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  backgroundColor: "#F266391A",
                                                  // border: "1px solid #FFDDD8",
                                                  borderRadius: "5px",
                                                  padding: "10px 12px",
                                                  // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                  width: "272px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "#F26639",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "16px",
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  {getInitials(person.label)}
                                                </div>
                                                <div style={{ flex: "1" }}>
                                                  <div
                                                    style={{
                                                      color: "#F26639",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.label,
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      color: "#000",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.role,
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="Handleremoveclosed">
                                                  <button
                                                    disabled={
                                                      ticketingRadioChecked ==
                                                      false
                                                    }
                                                    onClick={() =>
                                                      handleRemoveperson2(
                                                        person,
                                                      )
                                                    }
                                                  >
                                                    <img src={closebtnimg} />
                                                  </button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>

                              <div className="col-12 mb-4 ">
                                <div
                                  className="MatrixListhide"
                                  onClick={() => {
                                    setLevelThreePersonst(!LThreePersonsst);
                                  }}
                                >
                                  <span>L3</span>
                                  <img src={dropdownimg} />
                                </div>
                                {LThreePersonsst && (
                                  <>
                                    <div className="LevelListeds col-12">
                                      <div className="col-6 ">
                                        <label
                                          for="validationCustom01"
                                          class="form-label"
                                        >
                                          Person
                                          {ticketingRadioChecked == true && (
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <Select
                                          className="Selects "
                                          styles={customStyles}
                                          onChange={(e) => {
                                            handleLThreeUsers(e);
                                            setLthreeUserserr("");
                                          }}
                                          options={LthreeOptions}
                                          labelledBy="Select"
                                          isMulti
                                          value={
                                            ticketingRadioChecked == false
                                              ? []
                                              : LthreeUsers
                                          }
                                          onInputChange={handleInputuser}
                                          isDisabled={
                                            // data.l1_user != null && data.l1_user != undefined &&
                                            data.l1_user == null ||
                                            data.l1_user == undefined ||
                                            data.l1_user.length == 0 ||
                                            data.l2_user == null ||
                                            data.l2_user == undefined ||
                                            data.l2_user.length == 0
                                            // ||
                                            // ticketingRadioChecked == false
                                          }
                                        />
                                        <p className="Error">
                                          {LthreeUsersErr}
                                        </p>
                                      </div>

                                      <div
                                        className="col-6"
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Type
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <Select
                                            className="Selects "
                                            styles={{
                                              position: "relative",
                                              top: "60px",
                                            }}
                                            options={DurationOpions}
                                            labelledBy="Select"
                                            onChange={(e) => {
                                              HandleTheDurations(
                                                e,
                                                "l3time_type",
                                              );
                                              setL3TimeTypeErr("");
                                            }}
                                            // isDisabled={ticketingRadioChecked == false}

                                            value={Durationthreeval}
                                          />
                                          <p className="Error">
                                            {L3TimeTypeErr}
                                          </p>
                                        </div>

                                        <div className=" col-sm-3  ValidityData">
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            TAT
                                            {ticketingRadioChecked == true && (
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            )}
                                          </label>
                                          <input
                                            type="number" // Changed from "number" to "text" to better control input
                                            step="1"
                                            onKeyDown={(evt) => {
                                              preventZoom(evt);
                                            }}
                                            onPaste={(evt) => handlePaste(evt)} // Handle pasting
                                            onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                                            ref={inputRef}
                                            className="form-control"
                                            id="firstName"
                                            name="l3_user_TAT"
                                            value={data.l3_user_TAT}
                                            autoComplete="off"
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const phoneRegex =
                                                /^[1-9][0-9]{0,9}$/;
                                              const minutesRegex =
                                                /^([1-9]|[1-5][0-9])$/;

                                              // if ((phoneRegex.test(value) || value === '')) {
                                              //   HandleChanges(e);
                                              //   setL3UserTATErr("")
                                              // }

                                              if (data.l3_time_type == "0") {
                                                if (
                                                  minutesRegex.test(value) ||
                                                  value === ""
                                                ) {
                                                  HandleChanges(e);
                                                  setL3UserTATErr("");
                                                }
                                              } else if (
                                                phoneRegex.test(value) ||
                                                value === ""
                                              ) {
                                                HandleChanges(e);
                                                setL3UserTATErr("");
                                              }
                                            }}
                                          // disabled={ticketingRadioChecked == false}
                                          />

                                          <p className="Error">
                                            {L3UserTATErr}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    {LthreeUsers.length > 0 && (
                                      <div className="col-12 addedpeople">
                                        <div
                                          style={{ marginTop: "20px" }}
                                          className="col-12"
                                        >
                                          <h5>Added People</h5>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "15px",
                                              border: "1px solid #ddd",
                                              padding: "14px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {LthreeUsers.map((person) => (
                                              <div
                                                key={person.value}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  backgroundColor: "#F266391A",
                                                  // border: "1px solid #FFDDD8",
                                                  borderRadius: "5px",
                                                  padding: "10px 12px",
                                                  // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                  width: "272px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "#F26639",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "16px",
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  {getInitials(person.label)}
                                                </div>
                                                <div style={{ flex: "1" }}>
                                                  <div
                                                    style={{
                                                      color: "#F26639",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.label,
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      color: "#000",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {capitalizeEachWord(
                                                      person.role,
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="Handleremoveclosed">
                                                  <button
                                                    // disabled={ticketingRadioChecked == false}

                                                    onClick={() =>
                                                      handleRemoveperson3(
                                                        person,
                                                      )
                                                    }
                                                  >
                                                    <img src={closebtnimg} />
                                                  </button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>

                            <div className="col-12 InnerModelDesigns">
                              <div>Criticality</div>
                            </div>
                            <div className="row">
                              <>
                                <>
                                  <div className="col-12  SubcategoryBoxDesigns">
                                    {CategoryFields.map((category, index) => (
                                      <Fragment
                                        key={`${category?.categoryname.id}~${index}`}
                                      >
                                        <div className="col-12 cardofCategorys">
                                          <div
                                            className="InnereaderOfCate"
                                            onClick={() => {
                                              Handlethshow(
                                                category,
                                                index,
                                                !category?.categoryname
                                                  ?.Hideshow,
                                              ); // Toggle the Hideshow value
                                            }}
                                          >
                                            {category?.categoryname.name}
                                            <img src={dropdownimg} />
                                          </div>
                                        </div>

                                        <>
                                          {category?.categoryname?.Hideshow && (
                                            <>
                                              <div className="col-12 Subcategoryheader">
                                                <div>Sub Category</div>
                                                {category?.categoryname
                                                  .displaykey == false ? (
                                                  <div className="Categorybtns">
                                                    <button
                                                      onClick={() => {
                                                        let createval = 0;
                                                        console.log(
                                                          category,
                                                          "categorysdasdasdasd",
                                                        );
                                                        const hasEmptyFields =
                                                          category.categoryname.subcategorydata.some(
                                                            (subcategory) =>
                                                              subcategory.fieldsAdded &&
                                                              (!subcategory.name ||
                                                                !subcategory
                                                                  .Priority
                                                                  ?.label ||
                                                                !subcategory
                                                                  .is_active
                                                                  ?.label),
                                                          );

                                                        if (hasEmptyFields) {
                                                          toast.error(
                                                            "Please complete all fields before adding a new subcategory.",
                                                          );
                                                        } else {
                                                          HandletheSubcategory(
                                                            index,
                                                            category,
                                                          ); // Add new subcategory to this category
                                                        }
                                                      }}
                                                    >
                                                      Add
                                                    </button>
                                                  </div>
                                                ) : null}
                                              </div>

                                              <>
                                                {category?.categoryname?.subcategorydata?.map(
                                                  (subcategory, subIndex) => (
                                                    <>
                                                      <div
                                                        key={`${subcategory.issue_sub_id}~${subIndex}`}
                                                        className="col-6 SubInnercategoryBoxDesigns"
                                                      >
                                                        <div className="InnerCategorySub">
                                                          <div className="innerlabelbox innerlabelboxnames">
                                                            <input
                                                              name="name"
                                                              className={`${subcategory.issue_override
                                                                ? "changethecolor"
                                                                : ""
                                                                }`}
                                                              onChange={(
                                                                event,
                                                              ) => {
                                                                // className={`${category?.categoryname.issue_override ? "changethecolor" : ""}`} onChange={(event) => {
                                                                HandletheSubcategorychanges(
                                                                  index,
                                                                  subIndex,
                                                                  event,
                                                                  "name",
                                                                  subcategory,
                                                                );
                                                              }}
                                                              value={
                                                                subcategory.name ||
                                                                ""
                                                              }
                                                              disabled={
                                                                category
                                                                  ?.categoryname
                                                                  ?.displaykey
                                                              }
                                                              autocomplete="off"
                                                            />
                                                          </div>

                                                          <div className="Prioritystatus">
                                                            <div className="innerlabelbox">
                                                              <Select
                                                                value={
                                                                  subcategory.Priority
                                                                }
                                                                options={
                                                                  Priorityoptions
                                                                }
                                                                name="Priority"
                                                                onChange={(
                                                                  event,
                                                                ) => {
                                                                  HandletheSubcategorychanges(
                                                                    index,
                                                                    subIndex,
                                                                    event,
                                                                    "Priority",
                                                                    subcategory,
                                                                  );
                                                                }}
                                                                isDisabled={
                                                                  category
                                                                    ?.categoryname
                                                                    ?.displaykey
                                                                }
                                                              />
                                                            </div>
                                                          </div>

                                                          <div className="Prioritystatus">
                                                            <div className="innerlabelbox">
                                                              <Select
                                                                name="active"
                                                                onChange={(
                                                                  event,
                                                                ) => {
                                                                  HandletheSubcategorychanges(
                                                                    index,
                                                                    subIndex,
                                                                    event,
                                                                    "Activity",
                                                                    subcategory,
                                                                  );
                                                                }}
                                                                isDisabled={
                                                                  category
                                                                    ?.categoryname
                                                                    ?.displaykey
                                                                }
                                                                value={
                                                                  subcategory.is_active
                                                                }
                                                                options={
                                                                  optionsforfilter
                                                                }
                                                              />
                                                            </div>
                                                          </div>

                                                          {category
                                                            ?.categoryname
                                                            .displaykey ==
                                                            false ? (
                                                            <div className="SubcategoryEdits">
                                                              {subcategory?.fieldsAdded ==
                                                                false && (
                                                                  <button
                                                                    onClick={() => {
                                                                      HandletheSubofClient(
                                                                        subcategory,
                                                                        index,
                                                                        subIndex,
                                                                        category
                                                                          ?.categoryname
                                                                          ?.subcategorydata,
                                                                      );
                                                                    }}
                                                                  >
                                                                    save
                                                                  </button>
                                                                )}

                                                              {subcategory?.fieldsAdded ==
                                                                true ? (
                                                                <button
                                                                  onClick={() => {
                                                                    HandletheSubcreationsofClient(
                                                                      subcategory,
                                                                      index,
                                                                      subIndex,
                                                                    );
                                                                  }}
                                                                >
                                                                  save
                                                                </button>
                                                              ) : null}
                                                            </div>
                                                          ) : null}
                                                        </div>
                                                      </div>
                                                    </>
                                                  ),
                                                )}
                                              </>
                                            </>
                                          )}
                                        </>
                                      </Fragment>
                                    ))}
                                  </div>
                                </>
                              </>
                            </div>
                          </>
                        )}

                        <div className="UserButtons">
                          <button
                            class="btn Createbutton"
                            onClick={(e) => {
                              handleClosepop(e);
                            }}
                          >
                            Cancel
                          </button>

                          <button
                            class="btn  Createbutton"
                            type="submit"
                            onClick={(e) => {
                              HandleClick(e);
                              HandleEdit(e);
                            }}
                          >
                            {EditId == undefined || EditId == ""
                              ? "Submit Form"
                              : "Update Form"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientBranchCreate;
